/*
 *
 * Copyright (C) Cocouz Oy 2017 - All Rights Reserved
 */

import _ from 'lodash'
import moment from 'moment'
import Vue from 'vue'
import VueResource from 'vue-resource'
import Vuex from 'vuex'
import * as hf from '../assets/misc/helperFunctions.js'
import phoneNumberList from '../assets/misc/phoneNumbers.js'
import $ from 'jquery'
import cart from './modules/cart'
import cartAddons from './modules/cartAddons'
import VueCookie from 'vue-cookie'

Vue.use(VueResource)
Vue.use(Vuex)
Vue.use(VueCookie)

//Vue.http.options.root = 'http://meetingpackage.local'; // for local.
//Vue.http.options.root = 'http://empee.dd:8080'; // for local.
//Vue.http.options.root = 'http://localhost:8080'; // for local.

Vue.http.options.root =
  window.location.protocol +
  '//' +
  window.location.hostname + window.mp_url_settings['BASE_URL'] +
  (window.location.port ? ':' + window.location.port : '') // change to this for production
export default new Vuex.Store({
  modules: {
    cart,
    cartAddons
  },
  state: {
    layouts: {
      banquet: 399,
      boardroom: 400,
      cabaret: 401,
      classroom: 402,
      cocktail: 403,
      theater: 404,
      ushape: 405,
      island: 760
    },
    strings: {},
    selectedLang: '',
    //baseUrl : 'http://meetingpackage.local',
    //baseUrl : 'http://empee.dd:8080',
    //baseUrl: 'http://localhost:8080',
    baseUrl:
      window.location.protocol +
      '//' +
      window.location.hostname + (( window.location.hostname == 'stage-2.meetingpackage.com' || window.location.hostname == 'proxy-test.meetingpackage.com' || window.location.hostname == 'hotel-mice.com' || window.location.hostname == 'www.radissonhotels.com' || window.location.hostname == 'radissonhotels.com' || window.location.hostname == 'nwebuatlive.radissonhotels.com') ? window.mp_url_settings['BASE_URL'] : '')  +
      (window.location.port ? ':' + window.location.port : ''), // change to this for production
    alias: '',
    userInfo: '',
    venueInfo: '',
    allEquipment: '',
    roomInfo: '',
    packageInfo: '',
    currentTab: 'package',
    selectedPackage: '',
    selectedRoom: '',
    selectedLayout: '_none',
    selectedLayoutinPackage: '_none',
    rooms_in_package: '',
    layouts_in_room: '',
    layouts_in_room_in_package: '',
    eligiblePackages: '',
    eligibleRooms: '',
    meeting_length: '',
    delegates: '',
    datetime: '',
    endDatetime: '',
    date: '',
    end_date: '',
    time: '',
    end_time: '',
    price: '',
    selectedPrice: '',
    selectedPrice_decimal: '',
    p_price: '',
    p_selectedPrice: '',
    p_selectedPrice_decimal: '',
    currencySymbol: '',
    roomList: '',
    isInstantBookable: '',
    isInstantBookablePackage: '',
    perWhat: '',
    seatingOrderList: [],
    totalPriceIndicator: '',
    roomsLoaded: '',
    packagesLoaded: '',
    roomsReady: false,
    pmsPackageError: false,
    packagesReady: false,
    showLogo: false,
    sidebarState: false,
    footerCollided: false,
    detectedLanguage: '',
    translatedLanguage: '',
    //gtAPI: 'AIzaSyBPIy4hd1rUL25yNkIfIoRaRi0HDVwYcYY', // dev api key replace on live
    gtAPI: 'AIzaSyAG8nZP2rM8EXDUQZng5poLdCn6ZJg-4UA',
    isTranslated: false,
    isTranslating: false,
    selectedRoominPackage: '',
    allRoomsInPackages: '',
    showEnquiryForm: false,
    getImages: {},
    getThreeSixty: '',
    venueVideoLink: '',
    isRoomFormDisabled: false,
    isPackageFormDisabled: false,
    getRoomTranslation: [],
    isProcessing: false,
    userRole: '',
    IBRooms: '',
    venueAddons: [],
    selectedRoomIndex: '',
    selectedRoomIndexinPackage: '',
    isLoading: false,
    isPackageTabRemoved: false,
    minRoomNuminPackage: '',
    minRoomNum: '',
    countryPhoneCode: '',
    phoneNumberList: phoneNumberList,
    toggleDetailId: '',
    togglePackageDetailId: '',
    detailsText: false,
    detailsTextPackage: false,
    userPhone: '',
    showCheckOutPage: false,
    isOpera: false,
    isEndDateDisabled: false,
    checkOutItems: {},
    checkOutItemsOpera: [],
    addonsTotal: 0,
    roomPrice: '',
    roomTotalPrice: '',
    operaMenuItems: '',
    operaMiscItems: '',
    operaMenus: '',
    addOnCounter: 0,
    isRegus: false,
    showProcessingText: true,
    regusRoomInfo: '',
    selectedRegusRoom: '',
    regus_layout: '',
    noRegusRoom: false,
    regusCountry: '',
    regusState: '',
    regusStateMandatory: false,
    regusZipMandatory: false,
    isBE: false,
    useNewVenuePage: false,
    useNewCheckoutPage: false,
    isHanselWL: false,
    cartId: '',
    phone_country: {},
    packageMin: '',
    isMoreThanOneDay: false,
    eventList: [],
    defaultStartTime: window.isNCH == '1' ? '08:00' : '09:00',
    defaultEndTime: '17:00',
    finalEvents: [],
    tabIndex: 0,
    isJury: false,
    discount_code: '',
    discounted_amount: 0,
    isMultiDay: false,
    challengeRequired: false,
    challengeError: '',
    discountCodeLoading: false,
    discPriceErrorShouldShow: false,
    fkDelegatesErrorShouldShow: false,
    discountCodeInfo: '',
    roomBookingType: '',
    businessHours: '',
    isOutsideBusinessHours: false,
    serviceFeeWithEnquiry: false,
    checkoutComplete: false,
    checkoutDetails: {},
    checkoutDelegates: {},
    isNCHEnquiry: false,
    isNCH: false,
    showInfoModal: false,
    infoType: '',
    infoContent: '',
    premiumFeeAgree: false,
    originalUnitPrice: 0,
    roomPriceLabel: '',
    showBookAsEnquiryModal: false,
    showExpiredModal: false,
    showOperaEnquiryModal: false,
    isAirplus: false,
    isRedirecting: false,
    isClosed: false,
    selectedPosition: 0,
    isMews: false,
    airPlusConfig : {
      'AE' : '',
      'AK' : '',
      'AU' : '',
      'BD' : '',
      'DS' : '',
      'IK' : '',
      'KS' : '',
      'PK' : '',
      'PR' : '',
      'RZ' : '',
    },
    totalCartPrice: 0,
    showRatesFilter: 'all',
    showOperaError: false
  },
  getters: {
    getLayoutI18nByCode: (state, getters) => layoutCode => {
      let i18n = 'Anything goes'
      if (state.layouts_in_room.length > 0) {
        let found = state.layouts_in_room.find(layout => {
          return layout.value == layoutCode
        })
        if (found[0] && found[0].name) {
          i18n = found[0].name
        }
      }
      return i18n
    }
  },
  mutations: {

    setAirPlusConfig(state, data) {
      state.airPlusConfig[data.code] = data.value
    },
    setOriginalUnitPrice(state, data){
      state.originalUnitPrice = data;
    },
    setRoomPriceLabel(state, data){
      let roomPriceLabel = '';
			switch (data) {
				case 'fullday':
					roomPriceLabel = 'Full day price';
					break;
				case 'halfday':
					roomPriceLabel = 'Half day price';
					break;
				case 'hourly':
					roomPriceLabel = 'Hourly price';
					break;
				default:
					break;
			}
      state.roomPriceLabel = roomPriceLabel;
    },
    setPremiumFeeAgree(state, data){
      state.premiumFeeAgree = data;
    },
    setShowInfoModal(state, data){
      state.showInfoModal = data;
    },
    setInfoType(state, data){
      state.infoType = data;
    },
    setInfoContent(state, data){
      state.infoContent = data;
    },
    setBusinessHours(state, data) {
      state.businessHours = data
    },
    setSelectedPosition(state, data){
      state.selectedPosition = data + 1;
    },
    setServiceFeeWithEnquiry(state, data) {
      state.serviceFeeWithEnquiry = data
    },
    setOutsideBusinessHours(state, data) {
      state.isOutsideBusinessHours = data
    },
    setJurysInn(state, data) {
      let juryVenue = [92446, 91935]
      if (juryVenue.indexOf(parseInt(data)) > -1) {
        state.isJury = true
      } else {
        state.isJury = false
      }
    },
    setMewsVenue(state, data) {
      state.isMews = data
    },
    resetEventLists(state, data) {
      state.eventList = []
      state.finalEvents = []
      state.tabIndex = 0
    },
    setTabIndex(state, data) {
      let lastIndex = parseInt(state.eventList.length) - 1
      state.tabIndex = lastIndex >= parseInt(data) ? parseInt(data) : lastIndex
    },
    pushToFinalEvents(state, data) {
      state.finalEvents.push(data)
      state.finalEvents = _.orderBy(state.finalEvents, ['day'], ['asc'])
    },
    popToFinalEvents(state, data) {
      state.finalEvents = _.reject(state.finalEvents, function(el) {
        return parseInt(el.day) == parseInt(data)
      })
      state.eventList.forEach(element => {
        if (parseInt(element.day) == parseInt(data)) {
          element.isChosen = 0
        }
      })
    },
    popToEvents(state, data) {
      state.eventList = _.reject(state.eventList, function(el) {
        return parseInt(el.day) == parseInt(data)
      })
      state.eventList.forEach((element, index) => {
        element.day = index + 1
      })
    },
    setSelectedPackageForDay(state, data) {
      state.eventList.forEach(event_el => {
        if (parseInt(event_el.day) == parseInt(data.day)) {
          event_el.selected_package = data.packageID
          event_el.packages.forEach(package_el => {
            if (parseInt(package_el.id) == parseInt(data.packageID)) {
              event_el.room_list_in_package = package_el.rooms
              event_el.selected_room_in_package = package_el.rooms[0].id
            }
          })
        }
      })
    },
    setEventList(state, data) {
      state.eventList = data
    },
    setMoreThanOneDay(state, data) {
      state.isMoreThanOneDay = data
    },
    setPackageMin(state, data) {
      state.packageMin = data
    },
    setVenueAddons(state, addons) {
      state.venueAddons = addons
    },
    setCheckoutCompleted(state, checkoutComplete) {
      state.checkoutComplete = checkoutComplete
    },
    setCheckoutDetails(state, checkoutDetails) {
      state.checkoutDetails = checkoutDetails
    },
    setCheckoutDelegates(state, checkoutDelegates) {
      state.checkoutDelegates = checkoutDelegates
    },
    setDiscountedAmount(state, dicounted_amount) {
      state.discounted_amount = dicounted_amount
    },
    setDiscountCodeInfo(state, discountCodeInfo) {
      state.discountCodeInfo = discountCodeInfo
    },
    setShowProcessingText(state, showProcessingText) {
      state.showProcessingText = showProcessingText
    },
    showDiscPriceError(state, data) {
      state.discPriceErrorShouldShow = data
    },
    setFkDelegatesErrorShouldShow(state, data) {
      state.fkDelegatesErrorShouldShow = data
    },
    setDiscountCode(state, data) {
      state.discount_code = data
    },
    setBE(state, data) {
      state.isBE = data
    },
    setUseNewVenuePage(state, data) {
      state.useNewVenuePage = data
    },
    setUseNewCheckoutPage(state, data) {
      state.useNewCheckoutPage = data
    },
    setHanselWL(state, data) {
      state.isHanselWL = data
    },
    setRegusCountry(state, data) {
      state.regusCountry = data
    },
    setRegusState(state, data) {
      state.regusState = data
    },
    setRegusStateNeeded(state, data) {
      let isTrueSet = data == 'true'
      state.regusStateMandatory = isTrueSet
    },
    setRegusZipNeeded(state, data) {
      let isTrueSet = data == 'true'
      state.regusZipMandatory = isTrueSet
    },
    setAddonAjaxCounter(state, data) {
      state.addOnCounter += 1
    },
    setOperaMenus(state, data) {
      state.operaMenus = data
    },
    setOperaMenuItems(state, data) {
      state.operaMenuItems = data
    },
    setOperaMiscItems(state, data) {
      state.operaMiscItems = data
    },
    setRoomPrice(state, data) {
      state.roomPrice = data
    },
    setRoomTotalPrice(state, data) {
      state.roomTotalPrice = data
    },
    setCheckOutItems(state, data) {
      state.checkOutItems = data
    },
    setCheckOutItemsOpera(state, data) {
      state.checkOutItemsOpera = data
    },
    setAddonsTotal(state, data) {
      state.addonsTotal = data
    },
    changeLanguageData(state, data) {
      state.strings = data
    },
    getRoomTranslation(state, getRoomTranslation) {
      state.getRoomTranslation = getRoomTranslation
    },
    changeSelectedLang(state, lang) {
      state.selectedLang = lang
    },
    changeURL(state, lang) {
      let newURL = ''
      if (lang == 'en') {
        newURL = state.baseUrl + '/' + state.alias
      } else {
        newURL = state.baseUrl + '/' + lang + '/' + state.alias
      }
      this._vm.$cookie.set('venue_redirect_url', newURL, 100)
      window.history.pushState(null, null, newURL)
    },
    setAlias(state, alias) {
      state.alias = alias
    },
    setUserInfo(state, data) {
      state.userInfo = data
    },
    setVenueInfo(state, venue) {
      state.venueInfo = venue
    },
    setAllEquipment(state, allEquipment) {
      state.allEquipment = allEquipment
    },
    setIsMultiDay(state, isMultiDay) {
      state.isMultiDay = isMultiDay
    },
    setCartId(state, cartId) {
      state.cartId = cartId
    },
    setChallengeRequired(state, challengeRequired) {
      state.challengeRequired = challengeRequired
    },
    setChallengeError(state, challengeError) {
      state.challengeError = challengeError
    },
    setRoomInfo(state, rooms) {
      state.roomInfo = rooms
    },
    setRegusRoomInfo(state, rooms) {
      state.regusRoomInfo = rooms
    },
    setPackageInfo(state, packages) {
      state.packageInfo = packages
    },
    setSelectedPackage(state, packageID) {
      state.selectedPackage = packageID
    },
    setSelectedRoom(state, roomID) {
      state.selectedRoom = roomID
      // Set instant bookable as well.
      state.roomInfo.forEach(element => {
        if (element.id == roomID) {
          let ib = element.instant_bookable
          if (ib == '1') {
            state.isInstantBookable = true
          } else {
            state.isInstantBookable = false
          }
          switch (element.chosen_price) {
            case 'fullday':
              state.perWhat = state.strings.perFullDay
              state.totalPriceIndicator = 'unusual'
              break
            case 'halfday':
              state.perWhat = state.strings.perHalfDay
              state.totalPriceIndicator = 'unusual'
              break
            case 'normal':
              state.perWhat = state.strings.perHour
              state.totalPriceIndicator = 'usual'
              break
            case 'opera':
              state.perWhat = state.strings.perHour
              state.totalPriceIndicator = 'unusual'
              break
            default:
              state.perWhat = state.strings.perHour
              state.totalPriceIndicator = 'usual'
              break
          }
        }
      })
    },
    setRegusSelectedRoom(state, roomID) {
      state.selectedRegusRoom = roomID
      state.regusRoomInfo.forEach(element => {
        if (element.id == roomID) {
          state.totalPriceIndicator = 'unusual'
        }
      })
    },
    setSelectedRoominPackage(state, roomID) {
      state.selectedRoominPackage = roomID
      state.rooms_in_package.forEach(element => {
        if (element.id == roomID) {
          let ib = element.instant_bookable
          if (ib == '1') {
            state.isInstantBookablePackage = true
          } else {
            state.isInstantBookablePackage = false
          }
        }
      })
    },
    setSelectedLayout(state, layoutID) {
      state.selectedLayout = layoutID
    },
    setSelectedLayoutinPackage(state, layoutID) {
      state.selectedLayoutinPackage = layoutID
    },
    setRoomsBasedOnLayout(state, layoutID) {
      let roomList = state.roomInfo
      let newRoomList = []
      let layout_code = hf.getLayoutCode(layoutID)

      roomList.forEach(element => {
        let layout_object = element.room_layout
        for (let layout in layout_object) {
          if (layout == layout_code && layout_object[layout]) {
            newRoomList.push(element)
          }
        }
      })

      let roomID = newRoomList[0].id

      state.roomInfo = newRoomList
      state.selectedRoom = roomID
      // Set instant bookable as well.
      state.roomInfo.forEach(element => {
        if (element.id == roomID) {
          let ib = element.instant_bookable
          if (ib == '1') {
            state.isInstantBookable = true
          } else {
            state.isInstantBookable = false
          }
          switch (element.chosen_price) {
            case 'fullday':
              state.perWhat = state.strings.perFullDay
              state.totalPriceIndicator = 'unusual'
              break
            case 'halfday':
              state.perWhat = state.strings.perHalfDay
              state.totalPriceIndicator = 'unusual'
              break
            case 'normal':
              state.perWhat = state.strings.perHour
              state.totalPriceIndicator = 'usual'
              break
            case 'opera':
              state.perWhat = state.strings.perHour
              state.totalPriceIndicator = 'unusual'
              break
            default:
              state.perWhat = state.strings.perHour
              state.totalPriceIndicator = 'usual'
              break
          }
        }
      })
    },
    setPackagesBasedOnLayout(state, layoutID) {
      let packageList = state.packageInfo
    },
    setCurrentTab(state, currentTab) {
      state.currentTab = currentTab
    },
    setRoomsInPackage(state, rooms) {
      state.rooms_in_package = rooms
    },
    setLayoutsInRoom(state, selectedRoom) {
      if (state.currentTab == 'room') {
        state.roomInfo.forEach(element => {
          if (element.id == selectedRoom) {
            let layout_arr = [
              {
                value: '_none',
                name: `${state.strings.anythinggoes} / ${state.strings.idontknowyet}`
              }
            ]
            let layout_obj = element.room_layout
            let layout_obj_names = element.room_layout_i18n
            Object.keys(layout_obj).map((v, k) => {
              if (layout_obj[v] > 0 && v != 'field_collection_id') {
                let layout_item = {
                  value: state.layouts[v],
                  name: layout_obj_names[v] + ' (' + layout_obj[v] + ')',
                  max_delegate: layout_obj[v]
                }
                layout_arr.push(layout_item)
              }
            })

            state.layouts_in_room = layout_arr
            //state.selectedLayout = '_none'
          }
        })
      } else {
        state.rooms_in_package.forEach(element => {
          if (element.id == selectedRoom) {
            let layout_arr = [
              {
                value: '_none',
                name: `${state.strings.anythinggoes} / ${state.strings.idontknowyet}`
              }
            ]
            let layout_obj = element.room_layout
            let layout_obj_names = element.room_layout_i18n
            Object.keys(layout_obj).map((v, k) => {
              if (layout_obj[v] > 0 && v != 'field_collection_id') {
                let layout_item = {
                  value: state.layouts[v],
                  name: layout_obj_names[v] + ' (' + layout_obj[v] + ')',
                  max_delegate: layout_obj[v]
                }
                layout_arr.push(layout_item)
              }
            })

            state.layouts_in_room_in_package = layout_arr
            state.selectedLayoutinPackage = '_none'
          }
        })
      }
    },
    setRegusLayoutsInRoom(state, data) {
      state.regusRoomInfo.forEach(element => {
        if (element.id == data.room_id) {
          state.regus_layout = data.room_layout
        }
      })
    },
    setMeetingLength(state, mt_length) {
      state.meeting_length = mt_length
    },
    setDelegates(state, delegates) {
      state.delegates = delegates
    },
    setDateTime(state, datetime) {
      state.datetime = datetime
    },
    setSelectedPrice(state, payload) {
      if (state.currentTab == 'room') {
        state.price = payload.price
        state.selectedPrice = payload.selectedPrice
        state.selectedPrice_decimal = payload.selectedPrice_decimal
      } else {
        state.p_price = payload.price
        state.p_selectedPrice = payload.selectedPrice
        state.p_selectedPrice_decimal = payload.selectedPrice_decimal
      }
    },
    changeSelectedPrice(state, selectedRoom) {
      let price = ''
      let selectedPrice = ''
      let selectedPrice_decimal = ''
      let roomList = state.roomInfo
      let mt_length = state.meeting_length
      roomList.forEach(element => {
        if (element.id == selectedRoom) {
          switch (element.chosen_price) {
            case 'normal':
              price = element.calculated_prices?.price_vat / 100
              state.roomBookingType = 'hourly'
              break
            case 'halfday':
              price = element.calculated_prices?.halfday_price / 100
              state.roomBookingType = 'half_day'
              break
            case 'fullday':
              price = element.calculated_prices?.fullday_price / 100
              state.roomBookingType = 'full_day'
              break
            default:
              price = element.calculated_prices.price_vat / 100
              break
          }
          let tempPrice = ''
          if (element.chosen_price == 'normal') {
            tempPrice = (
              parseFloat(price * mt_length) / state.delegates
            ).toFixed(2)
          } else {
            tempPrice = (parseFloat(price) / state.delegates).toFixed(2)
          }

          price = parseFloat(price).toFixed(2)
          selectedPrice = tempPrice.toString().split('.')[0]
          selectedPrice_decimal =
            typeof tempPrice.toString().split('.')[1] == 'undefined'
              ? '00'
              : tempPrice.toString().split('.')[1]

          state.price = price
          state.selectedPrice = selectedPrice
          state.selectedPrice_decimal = selectedPrice_decimal
        }
      })
    },
    changeSelectedPricePackage(state, selectedPackage) {
      let price = ''
      let selectedPrice = ''
      let selectedPrice_decimal = ''
      let packagesList = state.packageInfo

      packagesList.forEach(element => {
        if (element.id == selectedPackage) {
          if (state.useNewVenuePage) {
            price = element.correct_price.price / 100
          } else {
            price = element.calculated_prices.price_vat / 100
          }
          price = parseFloat(price).toFixed(2)
          selectedPrice = price.toString().split('.')[0]
          selectedPrice_decimal =
            typeof price.toString().split('.')[1] == 'undefined'
              ? '00'
              : price.toString().split('.')[1]

          state.p_price = price
          state.p_selectedPrice = selectedPrice
          state.p_selectedPrice_decimal = selectedPrice_decimal
        }
      })
    },
    setCurrency(state, currency) {
      state.currencySymbol = currency
    },
    setRoomList(state, roomList) {
      state.roomList = roomList
    },
    roomsLoaded(state) {
      state.roomsLoaded = true
    },
    packagesLoaded(state) {
      state.packagesLoaded = true
    },
    roomsReady(state, data) {
      state.roomsReady = data
    },
    pmsPackageError(state, data) {
      state.pmsPackageError = data
    },
    packagesReady(state, data) {
      state.packagesReady = data
    },
    setSidebar(state, sidebarState) {
      state.sidebarState = sidebarState
    },
    setFooter(state, footerCollided) {
      state.footerCollided = footerCollided
    },
    setLeadTimes(state, data) {
      state.isClosed = data
    },
    showLogo(state, showLogo) {
      state.showLogo = showLogo
    },
    toggleDetailId(state, toggleDetailId) {
      state.toggleDetailId = toggleDetailId
    },
    togglePackageDetailId(state, togglePackageDetailId) {
      state.togglePackageDetailId = togglePackageDetailId
    },
    detailsText(state, detailsText) {
      state.detailsText = detailsText
    },
    detailsTextPackage(state, detailsTextPackage) {
      state.detailsTextPackage = detailsTextPackage
    },
    detectedLanguage(state, detectedLanguage) {
      state.detectedLanguage = detectedLanguage
    },
    translatedLanguage(state, translatedLanguage) {
      state.translatedLanguage = translatedLanguage
    },
    userRole(state, userRole) {
      state.userRole = userRole
    },
    isTranslated(state, isTranslated) {
      state.isTranslated = isTranslated
    },
    isTranslating(state, isTranslating) {
      state.isTranslating = isTranslating
    },
    setAllRoomsInPackages(state, rooms) {
      state.allRoomsInPackages = rooms
    },
    setNCHEnquiry(state, data) {
      if (data) {
        state.isNCHEnquiry = true
      } else {
        state.isNCHEnquiry = false
      }
    },
    setNCH(state, data) {
      if (data) {
        state.isNCH = true
      } else {
        state.isNCH = false
      }
    },
    setAirplus(state, data){
      if(data){
        state.isAirplus = true;
      } else {
        state.isAirplus = false;
      }
    },
    setShowEnquiryForm(state, data){
      if(data == 'yes'){
        state.showEnquiryForm = true;
      } else {
        state.showEnquiryForm = false
      }
    },
    getImages(state, getImages) {
      state.getImages = getImages
    },
    getThreeSixty(state, getThreeSixty) {
      state.getThreeSixty = getThreeSixty
    },
    venueVideoLink(state, venueVideoLink) {
      state.venueVideoLink = venueVideoLink
    },
    setRoomFormDisabled(state, data) {
      if (data == 'yes') {
        state.isRoomFormDisabled = true
      } else {
        state.isRoomFormDisabled = false
      }
    },
    setPackageFormDisabled(state, data) {
      if (data == 'yes') {
        state.isPackageFormDisabled = true
      } else {
        state.isPackageFormDisabled = false
      }
    },
    setProcessing(state, data) {
      if (data == 'yes') {
        state.isProcessing = true
      } else {
        state.isProcessing = false
      }
    },
    setIBRooms(state, data) {
      if (data.length >= state.IBRooms.length) {
        state.IBRooms = data
      }
    },
    setSelectedRoomIndex(state, data) {
      if (state.currentTab == 'room') {
        state.selectedRoomIndex = data
      } else {
        state.selectedRoomIndexinPackage = data
      }
    },
    setLoading(state, data) {
      state.isLoading = data
    },
    setDiscountCodeLoading(state, data) {
      state.discountCodeLoading = data
    },
    removePackageTab(state, data) {
      state.isPackageTabRemoved = true
    },
    setCountryPhoneCode(state, data) {
      state.countryPhoneCode = data
    },
    setDate(state, data) {
      state.date = data
      let time = state.time
      state.datetime = data + ' ' + time
    },
    setEndDate(state, data) {
      state.end_date = data
    },
    setTime(state, data) {
      state.time = data
      let date = state.date
      state.datetime = date + ' ' + data
    },
    setMinRoomNumberinPackage(state, data) {
      state.minRoomNuminPackage = data
    },
    setMinRoomNumber(state, data) {
      state.minRoomNum = data
    },
    setUserPhone(state, data) {
      state.userPhone = data
    },
    showCheckOutPage(state, data) {
      if (data == 'yes') {
        state.showCheckOutPage = true
      }
    },
    setOperaVenue(state, data) {
      state.isOpera = true
    },
    setIsEndDateDisabled(state, data) {
      state.isEndDateDisabled = data
    },
    setRegusVenue(state, data) {
      state.isRegus = true
    },
    setSeatingOrderList(state, data) {
      if (state.isJury) {
        state.seatingOrderList = [
          { id: 1, text: 'Anything goes', value: '_none' },
          { id: 3, text: 'Ushape', value: 405, code: 'USH' },
          { id: 4, text: 'Boardroom', value: 400, code: 'BDR' },
          { id: 5, text: 'Theater', value: 404, code: 'THT' },
          { id: 6, text: 'Classroom', value: 402, code: 'CLS' }
        ]
      } else {
        state.seatingOrderList = [
          { id: 1, text: 'Anything goes', value: '_none' },
          { id: 2, text: 'Cocktail', value: 403 },
          { id: 3, text: 'Ushape', value: 405 },
          { id: 4, text: 'Boardroom', value: 400 },
          { id: 5, text: 'Theater', value: 404 },
          { id: 6, text: 'Classroom', value: 402 },
          { id: 7, text: 'Banquet', value: 399 },
          { id: 8, text: 'Cabaret', value: 401 },
          { id: 9, text: 'Island', value: 760 }
        ]
      }
    },
    setRegusNoRoom(state, data) {
      if (data == true) {
        state.noRegusRoom = true
      } else {
        state.noRegusRoom = false
      }
    },
    getCurrentHost() {
      return window.location.host
    },
    setTotalPrice(state, price) {
      state.totalCartPrice = price
    },
    setEndDateTime(state, data) {
      state.endDatetime = data
    },
    setEndDate(state, data) {
      state.end_date = data
      let end_time = state.end_time
      state.endDatetime = data + ' ' + end_time
    },
    setEndTime(state, data) {
      state.end_time = data
      let end_date = state.end_date
      state.endDatetime = end_date + ' ' + data
    },
    setShowRatesFilter(state, data) {
      state.showRatesFilter = data
    },
    setShowOperaError(state, data) {
      state.showOperaError = data
    }
  },
  actions: {
    createNewDayTab({ dispatch, commit, state }, data) {
      let dayIndex = state.eventList.length + 1
      let defaultStartTime = state.defaultStartTime
      let defaultEndTime = state.defaultEndTime
      let defaultDate = state.date
      let defaultDelegates = state.delegates
      state.eventList.forEach(event => {
        if (event.day == dayIndex - 1) {
          // Get the last event
          defaultStartTime = event.start_time
          defaultEndTime = event.end_time
          defaultDate = moment(event.date, 'DD-MM-YYYY')
            .add(1, 'days')
            .format('DD-MM-YYYY')
          defaultDelegates = parseInt(event.delegates)
        }
      })
      // Need to check the day before and assign that day's settings.

      state.eventList.push({
        day: dayIndex,
        start_time: defaultStartTime,
        end_time: defaultEndTime,
        delegates: defaultDelegates,
        date: defaultDate
      })

      //commit('setTabIndex', parseInt(dayIndex));

      let payload = {
        day: dayIndex,
        date: defaultDate,
        startTime: defaultStartTime,
        endTime: defaultEndTime,
        delegates: defaultDelegates
      }

      dispatch('checkBizHours', payload)

      if (state.currentTab == 'room') {
        if (state.isOpera) {
          dispatch('getOperaRoomForEachDay', payload)
        } else {
          dispatch('getRoomForEachDay', payload)
        }
      } else {
        if (state.isOpera) {
          dispatch('getOperaPackageForEachDay', payload)
        } else {
          // Not yet developed.
        }
      }
    },

    chooseRoomLayout({ commit, state, dispatch, rootState }, data) {
      const currentCheckOutItems = rootState.cart
      const payload = {
        ...currentCheckOutItems.events[0].room,
        layout: data, 
        layout_name: state.strings.layouts[data],
        layout_name_en: state.strings.layouts[data]
      }
      commit('setCheckoutItemRoom', payload);
      localStorage.setItem('checkOutItems', JSON.stringify(payload));
    },

    checkBizHours({ commit, state }, data) {
      let currentTab = state.currentTab
      let isOpera = state.isOpera
      if (data) {
        // Check business hours in each day for multidays booking.

        let day = data.day
        let date = data.date
        let startTime = data.startTime
        let endTime = data.endTime
        let bizHours = hf.businessHours(
          state.venueInfo.venue_business_hours,
          date
        )

        var params = {
          startTimeObj: moment(startTime, 'HH:mm'),
          endTimeObj: moment(endTime, 'HH:mm'),
          bizHours: bizHours
        }

        let isOutsideBusinessHours = hf.checkBusinessHours(params)
        if (currentTab == 'package' && isOpera) {
          isOutsideBusinessHours = false
        }

        // Put the business hours and the flag to the event list.
        let _event = state.eventList

        _event.forEach(event_el => {
          if (parseInt(day) == parseInt(event_el.day)) {
            (event_el.bizHours = bizHours),
              (event_el.outOfBizHours = isOutsideBusinessHours)
          }
        })
      } else {
        // Check business hours for normal booking.

        let bizHours = hf.businessHours(
          state.venueInfo.venue_business_hours,
          state.datetime
        )
        commit('setBusinessHours', bizHours)

        var params = {
          startTimeObj: moment(state.time, 'HH:mm'),
          mtLength: state.meeting_length,
          bizHours: bizHours
        }

        let isOutsideBusinessHours = hf.checkBusinessHours(params)

        if (currentTab == 'package' && isOpera) {
          isOutsideBusinessHours = false
        }

        if (!isOutsideBusinessHours) {
          commit('setOutsideBusinessHours', false)
        } else {
          commit('setOutsideBusinessHours', true)
        }
      }
    },
    checkLeadTimes({ commit, state }, data) {
      if(state.venueInfo){
        let disabled_days = state.venueInfo.lead_times ? state.venueInfo.lead_times.disabled_days : '';
        let disabled_week_days = state.venueInfo.lead_times ? state.venueInfo.lead_times.disabled_week_days : '';
        if(disabled_days || disabled_week_days){
          let date = moment(state.date, 'DD-MM-YYYY');
          let currentWeekDay = date.day();
          let dateToString = date.format('DD-MM-YYYY');
          if(disabled_days.indexOf(dateToString) > -1){
            commit('setLeadTimes', true);
          } else if(disabled_week_days.indexOf(currentWeekDay) > -1){
            commit('setLeadTimes', true);
          } else {
            commit('setLeadTimes', false);
          }
        } else {
          commit('setLeadTimes', false);
        }
      } else {
        commit('setLeadTimes', false);
      }
    },
    goToCheckout({commit, state}, data){
      commit('setProcessing', 'yes');
      localStorage.removeItem('checkoutDetails');
      let currency = state.venueInfo.currency_code;
      let currentTab = state.currentTab;
      let _events = [];
      let totalPrice = 0;
      let layoutI18n = state.strings.layouts[state.selectedLayout];
      let layoutI18nPackage = state.strings.layouts[state.selectedLayoutinPackage];
      if(state.isMoreThanOneDay){
        state.finalEvents.forEach(event_el => {
          let startEventDate = moment(
            event_el.date + ' ' + event_el.start_time,
            'DD-MM-YYYY HH:mm'
          )
          let _mpStartDate = startEventDate.format('DD-MM-YYYY HH:mm')
          let _mpEndDate = moment(
            startEventDate.format('DD-MM-YYYY') + ' ' + event_el.end_time,
            'DD-MM-YYYY HH:mm'
          ).format('DD-MM-YYYY HH:mm')

          let _startD_m = moment(_mpStartDate, 'DD-MM-YYYY HH:mm')
          let _endD_m = moment(_mpEndDate, 'DD-MM-YYYY HH:mm')

          let _duration = moment.duration(_endD_m.diff(_startD_m))
          let _mt_length = parseInt(_duration.asHours())
          if (currentTab == 'room') {
            event_el.finalList.forEach(room_el => {
              if (parseInt(room_el.id) == parseInt(event_el.selected_room)) {
                totalPrice += parseFloat(event_el.selected_room_price) / 100
                _events.push({
                  id: room_el.id,
                  title: room_el.title,
                  type: 'room',
                  duration: _mt_length,
                  layout: state.selectedLayout,
                  layout_i18n: layoutI18n,
                  delegates: event_el.delegates,
                  instant_bookable: room_el.instant_bookable,
                  start: _mpStartDate,
                  end: _mpEndDate,
                  addons: [],
                  unit_price: event_el.selected_room_price / 100,
                  total_price: event_el.selected_room_price / 100,
                  addons_total: 0,
                  services_total: 0
                })
              }
            })
          }
        })
      } else {
        if(currentTab == 'room'){
          let selectedRoomInfo = state.roomInfo.find(obj => obj.id == data.room);
          let _startD_m = moment(data.start, 'DD-MM-YYYY HH:mm');
          let _endD_m = moment(data.end, 'DD-MM-YYYY HH:mm');
          let _duration = moment.duration(_endD_m.diff(_startD_m));
          let _mt_length = parseInt(_duration.asHours());
          totalPrice += parseFloat(data.room_price_total);
          if(data.chosenPriceType == 'normal'){
            data.chosenPriceType = 'hourly';
          }
          _events.push({
            "id" : selectedRoomInfo.id,
            "title": selectedRoomInfo.title,
            "type": "room",
            "duration": _mt_length,
            'layout' : state.selectedLayout,
            'layout_i18n': layoutI18n,
            "delegates": data.delegates,
            "instant_bookable": data.isInstantBookable,
            "start": data.start,
            "end": data.end,
            "addons": [],
            "duration_type": data.chosenPriceType,
            "unit_price": data.room_price,
            "total_price": data.room_price_total,
            "addons_total": 0,
            "services_total": 0
          });
        } else {

          let selectedPackageInfo = state.packageInfo.find(obj => obj.id == data.package_id);
          let selectedRoomInPackageInfo = state.rooms_in_package.find(obj => obj.id == data.room);
          totalPrice += parseFloat(data.package_price_total);
          _events.push({
            "id" : selectedPackageInfo.id,
            "package_title": selectedPackageInfo.title,
            "title": selectedRoomInPackageInfo.title,
            "room_id": selectedRoomInPackageInfo.id,
            "package_min": selectedPackageInfo.package_min,
            "package_includes": selectedPackageInfo.services,
            "type": "package",
            'layout' : state.selectedLayoutinPackage,
            'layout_i18n': layoutI18nPackage,
            "delegates": data.delegates,
            "instant_bookable": data.isInstantBookable,
            "start": data.start,
            "end": data.end,
            "addons": [],
            "unit_price": data.package_price,
            "total_price": data.package_price_total,
            "addons_total": 0,
            "services_total": 0
          });

        }
      }

      let bookingStart = _events[0].start
      let bookingEnd = _events[_events.length - 1].end

      let checkoutPayload = {
        "applicable_layouts": data.applicable_layouts,
        "language": state.selectedLang,
        "enquiry": state.isNCHEnquiry || state.showEnquiryForm || ( _events[0] && _events[0].total_price == 0),
        "start": bookingStart,
        "end": bookingEnd,
        "discount_code": state.discount_code,
        "total": totalPrice,
        "addons_total": 0,
        "services_total": 0,
        "events": _events,
        "venue": {
          "title": state.venueInfo.title,
          "currency_symbol": state.venueInfo.currency,
          "id": state.venueInfo.id,
          "currency": currency,
          "terms": state.venueInfo.terms,
          "terms_of_cancellation": state.venueInfo.terms_of_cancellation,
          "terms_of_use": state.venueInfo.terms_of_use,
          "photos": state.venueInfo.venue_pictures.slice(1, 6),
          "service_fee": state.venueInfo.service_fee
        }
      };

      //checkoutPayload.venue.photos = [ "https://d1whte2dpudn87.cloudfront.net/venue/tak-at-six.jpg", "https://d1whte2dpudn87.cloudfront.net/styles/horizontal_slider_image/public/venue/tak-at-six.jpg?itok=a-61IAWG"]
      checkoutPayload.venue.photos = state.venueInfo.venue_pictures.slice(1, 6);
      localStorage.setItem('checkOutItems', JSON.stringify(checkoutPayload));

      let url = '';
      let lang = state.selectedLang;
      if(lang == 'en'){
        lang = '';
      } else {
        lang = '/' + lang
      }
      if(state.isNCH){
        url = state.baseUrl + lang + '/book'
      } else {
        url = state.baseUrl + lang + '/checkout';
      }
      window.location.href = data.orderId ? url + '/' + data.orderId : url;
    },
    goToOperaCheckout({commit, state}, data){
      commit('setProcessing', 'yes');
      let payload = [];
      let selectedRoomId = data.room_id;
      let currency = state.venueInfo.currency_code;
      let currencySymbol = state.venueInfo.currency;
      let type = state.currentTab == 'room' ? 'room' : 'package';
      let currentTab = state.currentTab;
      let delegates = state.delegates;
      let operaPriceSource = state.venueInfo.operaRoomPriceSource;
      if(state.isMoreThanOneDay){
        state.finalEvents.forEach(event_el => {
          let photos = []
          let startEventDate = moment(
            event_el.date + ' ' + event_el.start_time,
            'DD-MM-YYYY HH:mm'
          )

          // Date stuff.
          // Opera
          let _operaStartDate = startEventDate.format('YYYY-MM-DDTHH:mm:ss')
          let _operaEndDate = moment(
            startEventDate.format('YYYY-MM-DD') +
              'T' +
              event_el.end_time +
              ':00',
            'YYYY-MM-DDTHH:mm:ss'
          ).format('YYYY-MM-DDTHH:mm:ss')

          // Normal

          let _mpStartDate = startEventDate.format('DD-MM-YYYY HH:mm')
          let _mpEndDate = moment(
            startEventDate.format('DD-MM-YYYY') + ' ' + event_el.end_time,
            'DD-MM-YYYY HH:mm'
          ).format('DD-MM-YYYY HH:mm')

          let _startD_m = moment(_mpStartDate, 'DD-MM-YYYY HH:mm')
          let _endD_m = moment(_mpEndDate, 'DD-MM-YYYY HH:mm')

          let _duration = moment.duration(_endD_m.diff(_startD_m))
          let _mt_length = parseInt(_duration.asHours())

          let room = {}
          let _package = {}
          let total_price = 0
          if (currentTab == 'room') {
            event_el.finalList.forEach(room_el => {
              if (parseInt(room_el.id) == parseInt(event_el.selected_room)) {
                let selectedPrice = 0
                /*if ((_mt_length >= 2) & (_mt_length <= 5)) {
                  selectedPrice = room_el.calculated_prices.halfday_price
                } else {
                  selectedPrice = room_el.calculated_prices.fullday_price
                }*/
                selectedPrice = event_el.selected_room_price;

                room = {
                  isInstantBookable: room_el.instant_bookable,
                  rate_code: room_el.rate_code,
                  code: room_el.code,
                  name: room_el.title,
                  layout_code: state.selectedLayout,
                  opera_layout_code: hf.MPLayoutToOperaLayout(
                    state.selectedLayout,
                    state.venueInfo.operaServer
                  ),
                  layout_name: hf.getLayoutName(state.selectedLayout),
                  id: room_el.id,
                  price_novat: '',
                  unit_price: selectedPrice,
                  total_price: selectedPrice
                }
                total_price = room.total_price
              }
            })
          } else {
            event_el.packages.forEach(package_el => {
              if (
                parseInt(package_el.id) == parseInt(event_el.selected_package)
              ) {
                let correctDelegates =
                  parseInt(event_el.delegates) <
                  parseInt(package_el.package_min)
                    ? parseInt(package_el.package_min)
                    : parseInt(event_el.delegates)
                _package = {
                  rate_code: package_el.package_rate_code,
                  name: package_el.title,
                  id: package_el.id,
                  package_min: parseInt(package_el.package_min),
                  unit_price: package_el.calculated_prices.price_vat,
                  total_price:
                    parseInt(package_el.calculated_prices.price_vat) *
                    correctDelegates
                }
                total_price = _package.total_price
              }
            })
            event_el.room_list_in_package.forEach(room_el => {
              if (
                parseInt(room_el.id) ==
                parseInt(event_el.selected_room_in_package)
              ) {
                room = {
                  isInstantBookable: room_el.instant_bookable,
                  code: room_el.code,
                  name: room_el.title,
                  id: room_el.id,
                  layout_code: state.selectedLayoutinPackage,
                  opera_layout_code: hf.MPLayoutToOperaLayout(
                    state.selectedLayoutinPackage,
                    state.venueInfo.operaServer
                  ),
                  layout_name: hf.getLayoutName(state.selectedLayoutinPackage)
                }
              }
            })
          }

          let finalItem = {
            operaStartD: _operaStartDate,
            operaEndD: _operaEndDate,
            startD: _mpStartDate,
            endD: _mpEndDate,
            endTime: event_el.end_time,
            mt_length: _mt_length,
            type: type,
            currency: currency,
            currencySymbol: currencySymbol,
            delegates: event_el.delegates,
            room: room,
            package: _package,
            services: [],
            addons: [],
            total_services: 0,
            total_addons: 0,
            total_price: total_price
          }
          payload.push(finalItem)
        })
      } else {
        let room = {}
        let _package = {}
        let total_price = 0

        let _startD_m = moment(data.startD, 'DD-MM-YYYY HH:mm')
        let _endD_m = moment(data.endD, 'DD-MM-YYYY HH:mm')

        let _duration = moment.duration(_endD_m.diff(_startD_m))
        let _mt_length = parseInt(_duration.asHours())

        if (currentTab == 'room') {
          let selectedRoomInfo = state.roomInfo.find(
            obj => obj.id == selectedRoomId
          )
          let selectedPrice = 0
          if ((_mt_length >= 2) & (_mt_length <= 5)) {
            selectedPrice = selectedRoomInfo.calculated_prices.halfday_price
          } else {
            selectedPrice = selectedRoomInfo.calculated_prices.fullday_price
          }
          room = {
            isInstantBookable: data.isInstantBookable,
            code: data.room_code,
            id: data.room_id,
            name: data.room,
            layout_name: data.layout_name,
            layout_code: data.layout_code,
            opera_layout_code: data.opera_layout_code,
            rate_code: data.room_rate_code,
            unit_price: data.room_price_option.total_price,
            total_price: data.room_price_option.total_price,
          }
          total_price = room.total_price
        } else {
          let selectedPackageInfo = state.packageInfo.find(
            obj => obj.id == state.selectedPackage
          )
          let correctDelegates =
            parseInt(delegates) < parseInt(selectedPackageInfo.package_min)
              ? parseInt(selectedPackageInfo.package_min)
              : parseInt(delegates)
          _package = {
            id: data.package_code,
            name: data.package,
            rate_code: data.package_rate_code,
            package_min: parseInt(selectedPackageInfo.package_min),
            total_price:
              selectedPackageInfo.calculated_prices.price_vat *
              correctDelegates,
            unit_price: selectedPackageInfo.calculated_prices.price_vat
          }

          room = {
            isInstantBookable: data.isInstantBookable,
            code: data.room_code,
            name: data.room,
            id: data.room_id,
            layout_name: data.layout_name,
            layout_code: data.layout_code,
            opera_layout_code: data.opera_layout_code
          }
          total_price =
            selectedPackageInfo.calculated_prices.price_vat * correctDelegates
        }

        let item = {
          addons: [],
          services: [],
          currency: currency,
          currencySymbol: currencySymbol,
          delegates: delegates,
          startD: data.startD,
          endD: data.endD,
          operaStartD: data.operaStartD,
          operaEndD: data.operaEndD,
          mt_length: _mt_length,
          type: data.type,
          room: room,
          package: _package,
          total_addons: 0,
          total_price: total_price,
          total_services: 0
        }
        payload.push(item)
      }

      let venue_payload = {
        title: state.venueInfo.title,
        id: state.venueInfo.id,
        currency: currency,
        hotel_code: state.venueInfo.operaHotelID,
        server: state.venueInfo.operaServer,
        chain_code: state.venueInfo.operaChainCode,
        source_id: state.venueInfo.sourceID,
        terms: state.venueInfo.terms,
        terms_of_cancellation: state.venueInfo.terms_of_cancellation,
        inquiry_venue_terms_cancellation: state.venueInfo.inquiry_venue_terms_cancellation,
        photos: state.venueInfo.venue_pictures.slice(0, 5)
      }
      let finalPayload = []
      finalPayload.push(payload)
      finalPayload.push(venue_payload)

      localStorage.setItem('operaPayload', JSON.stringify(finalPayload))

      let url = ''
      let lang = state.selectedLang
      if (lang == 'en') {
        lang = ''
      } else {
        lang = '/' + lang
      }
      url = state.baseUrl + lang + '/book'
      window.location.href = url
    },
    changeLanguage({ commit, state }, data) {
      // Get language on url and apply it to the page.
      commit('changeSelectedLang', data.lang)
      if (data.alias == 'yes') {
        commit('changeURL', data.lang)
      } else {
        commit('setAlias', data.alias)
      }
      Vue.http.post(state.baseUrl + '/' + 'apiv2/venuepackage/text', { lang: data.lang }).then(
        response => {
          // get body data
          let data = response.body
          commit('changeLanguageData', data)
          if($('.backtosite').length > 0) {
            $('.backtosite a').html(data.backToWebsite)
          }
          if($('.backtositebottom').length > 0) {
            $('.backtositebottom a').first().html(data.backToWebsite)
          }
        },
        response => {}
      )
    },
    checkUser({ commit, state }) {
      return new Promise((resolve, reject) => {
        Vue.http.post( state.baseUrl + '/' + 'apiv2/user/info').then(
          response => {
            let data = response.body

            _.find(data.roles, function(o) {
              if (o == '7') {
                commit('userRole', 'supplier')
              }

              if (o == '4') {
                commit('userRole', 'customer')
              }

              if (o == '3') {
                commit('userRole', 'admin')
              }
            })

            commit('setUserInfo', data)

            if (data) {
              commit('setUserPhone', data.phone)
            }
            resolve()
          },
          response => {}
        )
      })
    },
    getSessionToken({commit, state}, data){
      return new Promise((resolve,reject) => {
        Vue.http.post(state.baseUrl + '/' + 'services/session/token').then(response => {
          resolve(response);
          }, response => {
          });
      })
    },
    loginUser({dispatch, commit, state}, data){
      return dispatch("getSessionToken").then( (response)=>{
        let headers = {
          'X-CSRF-Token': response.body,
          'Content-Type': 'application/json;charset=utf-8'
        };
        return new Promise((resolve,reject) => {
          Vue.http.post(state.baseUrl + '/' + 'apiv2/user/login', data,  {headers: headers}).then(response => {
            resolve(response);
            }, response => {
              if(response.status == 401){
                resolve("wrong_password");
              }
              resolve("unknown_error");
            });
        })
      });

    },
    createUser({commit, state}, data){
      return new Promise((resolve,reject) => {
        Vue.http.post(state.baseUrl + '/' + 'apiv2/user/create', data).then(response => {
          resolve(response);
          }, response => {
          });
      })
    },
    createOperaCart({dispatch, commit, state}, data){
      Vue.http.post(state.baseUrl + '/' + 'apiv2/opera/create-cart', data)
        .then(response => {
          let data = response.body;
          commit('setCartId', data.id);
        }, error => {

        });
    },
    getVenue({ dispatch, commit, state }, data) {
      return new Promise((resolve, reject) => {
        if (!data.venueID) {
          reject('venue_id not set')
        }

        Vue.http.get(state.baseUrl + '/' + 'apiv2/venues/' +data.venueID + '/' + data.lang + '/?v=1000').then(response => {

          let data = response.body;
          commit('setVenueInfo', data);
          commit('setAllEquipment', data.all_equipment)
          dispatch('checkLeadTimes');
          // if(!!data.operaHotelID){
          //   commit('setOperaVenue');
          // }
          
          if(!data.venue_business_hours){
            commit('setOutsideBusinessHours', false);
          } else {
            let bizHours = hf.businessHours(data.venue_business_hours, state.datetime);
            commit('setBusinessHours', bizHours);
  
            let isOutsideBusinessHours = hf.checkBusinessHours( state.time, state.meeting_length, bizHours);

            if(state.currentTab == 'package' && state.isOpera){
              isOutsideBusinessHours = false;
            }
  
            if(!isOutsideBusinessHours){
              commit('setOutsideBusinessHours', false);
            } else {
              commit('setOutsideBusinessHours', true);
            }
          }

              if (!data.venue_business_hours) {
                commit('setOutsideBusinessHours', false)
              } else {
                let bizHours = hf.businessHours(
                  data.venue_business_hours,
                  state.datetime
                )
                commit('setBusinessHours', bizHours)

                let isOutsideBusinessHours = hf.checkBusinessHours(
                  state.time,
                  state.meeting_length,
                  bizHours
                )

                if (state.currentTab == 'package' && state.isOpera) {
                  isOutsideBusinessHours = false
                }

                if (!isOutsideBusinessHours) {
                  commit('setOutsideBusinessHours', false)
                } else {
                  commit('setOutsideBusinessHours', true)
                }
              }

              dispatch('checkBizHours')

              commit('setJurysInn', data.id)

              if(data.mews_id){
                commit('setMewsVenue', true);
              }
              $('.iswhitelabel footer').css('display', 'block')

              commit('setSeatingOrderList', data)
              let packageLength = data.packageLength

              if (packageLength == 0) {
                state.currentTab = 'room'
                commit('removePackageTab')
              }

              if (state.currentTab == 'package') {
                if (state.isOpera) {
                  // Change after demo
                  dispatch('getOperaPackage', data.id).then(result => {})
                } else {
                  dispatch('getPackage', {useNewAPI: false}).then(result => {})
                }
              } else {
                if (state.isOpera) {
                  dispatch('getRoomOpera').then(result => {})
                } else if (state.isRegus) {
                  dispatch('getRoomRegus').then(result => {})
                } else {
                  dispatch('getRoom', {useNewAPI: false})
                }
              }

              commit('getThreeSixty', data.threesixty_pic)
              commit('venueVideoLink', data.venue_video_embed)
              commit('getImages', data.venue_pictures)

              commit('setCurrency', data.currency)

              // Disable detect language on dev, stage & mpfeature
              let siteUrl = window.location.hostname
              //if(siteUrl != 'dev.meetingpackage.com' && siteUrl != 'stage.meetingpackage.com' && siteUrl != 'mpfeature.meetingpackage.com'){
              dispatch('gTranslateDetect', data.description).then(result => {})
              //}
              commit('translatedLanguage', data.description)
              resolve(data)
            },
            response => {}
          )
      })
    },
    getNewVenue({ dispatch, commit, state }, data) {
      return new Promise((resolve, reject) => {
        if (!data.venueID) {
          reject('venue_id not set')
        }

        let apiURL = state.baseUrl + `/apiv2/venues/${data.venueID}/${data.lang}`
        
        // Apply discount code if there is one
        if (state.discount_code) {
          apiURL += `&discount_code=${state.discount_code}`
        }

        Vue.http.get(apiURL).then(response => {

          let data = response.body;
          commit('setVenueInfo', data);
          commit('setAllEquipment', data.all_equipment)
          dispatch('checkLeadTimes');
          // if(!!data.operaHotelID){
          //   commit('setOperaVenue');
          // }
          
          if(!data.venue_business_hours){
            commit('setOutsideBusinessHours', false);
          } else {
            let bizHours = hf.businessHours(data.venue_business_hours, state.datetime);
            commit('setBusinessHours', bizHours);
  
            let isOutsideBusinessHours = hf.checkBusinessHours( state.time, state.meeting_length, bizHours);

            if(state.currentTab == 'package' && state.isOpera){
              isOutsideBusinessHours = false;
            }
  
            if(!isOutsideBusinessHours){
              commit('setOutsideBusinessHours', false);
            } else {
              commit('setOutsideBusinessHours', true);
            }
          }

              if (!data.venue_business_hours) {
                commit('setOutsideBusinessHours', false)
              } else {
                let bizHours = hf.businessHours(
                  data.venue_business_hours,
                  state.datetime
                )
                commit('setBusinessHours', bizHours)

                let isOutsideBusinessHours = hf.checkBusinessHours(
                  state.time,
                  state.meeting_length,
                  bizHours
                )

                if (state.currentTab == 'package' && state.isOpera) {
                  isOutsideBusinessHours = false
                }

                if (!isOutsideBusinessHours) {
                  commit('setOutsideBusinessHours', false)
                } else {
                  commit('setOutsideBusinessHours', true)
                }
              }

              dispatch('checkBizHours')

              commit('setJurysInn', data.id)

              if(data.mews_id){
                commit('setMewsVenue', true);
              }
              $('.iswhitelabel footer').css('display', 'block')

              commit('setSeatingOrderList', data)
              let packageLength = data.packageLength

              if (packageLength == 0) {
                state.currentTab = 'room'
                commit('removePackageTab')
              }

              // if (!state.isRegus) {
              //   dispatch('getPackage', {useNewAPI: true, packages: data.packages})
              // }
              // dispatch('getRoom', {useNewAPI: true, meeting_rooms: data.meeting_rooms})

              commit('getThreeSixty', data.threesixty_pic)
              commit('venueVideoLink', data.venue_video_embed)
              commit('getImages', data.venue_pictures)

              commit('setCurrency', data.currency)

              // Disable detect language on dev, stage & mpfeature
              let siteUrl = window.location.hostname
              //if(siteUrl != 'dev.meetingpackage.com' && siteUrl != 'stage.meetingpackage.com' && siteUrl != 'mpfeature.meetingpackage.com'){
              dispatch('gTranslateDetect', data.description).then(result => {})
              //}

              dispatch('fetchPackageAndRoom', {venueID: state.venueInfo.id})
              commit('translatedLanguage', data.description)
              resolve(data)
            },
            response => {}
          )
      })
    },
    fetchPackageAndRoom ({ dispatch, commit, state }, data) {
      if (!data.venueID) {
        return
      }

      commit('roomsReady', false)

      if (!state.isRegus) {
        commit('packagesReady', false)
      }

      let startDate = moment(state.datetime, 'DD-MM-YYYY HH:mm').format('DD-MM-YYYY HH:mm')
      let endDate = moment(state.endDatetime, 'DD-MM-YYYY HH:mm').format('DD-MM-YYYY HH:mm')
      let delegates = state.delegates
      let lang = state.selectedLang;
      let selectedLayout = state.selectedLayout
      
      return new Promise((resolve, reject) => {
        if (!data.venueID) {
          reject('venue_id not set')
        }

        let apiURL = state.baseUrl +  `/apiv2/availability/${data.venueID}?start=${startDate}&end=${endDate}&lang=${lang}&delegates=${delegates}&layout=${selectedLayout}`
        
        // Apply discount code if there is one
        if (state.discount_code) {
          apiURL += `&discount_code=${state.discount_code}`
        }

        Vue.http.get(apiURL).then(response => {
          let data = response.body;
          // No Package for Regus
          if (!state.isRegus) {
            dispatch('getPackage', {useNewAPI: true, packages: data.packages})
          }
          dispatch('getRoom', {useNewAPI: true, meeting_rooms: data.meeting_rooms, packages: data.packages})
          commit('roomsReady', true)
          resolve()
        })
      })
    },
    fetchMultipleRoomPrices({dispatch, commit, state }, events) {
      return new Promise((resolve,reject) => {
        Vue.http.post(state.baseUrl + '/' + 'apiv2/multiple-room-price', events).then(response => {
           return resolve(response);
          }, response => {
        });
      });
    },
    fetchMultiplePackagePrices({dispatch, commit, state }, events) {
      return new Promise((resolve,reject) => {
        Vue.http.post(state.baseUrl + '/' + 'apiv2/multiple-package-price', events).then(response => {
           return resolve(response);
          }, response => {
        });
      });
    },
    fetchMPRooms({dispatch, commit, state }, payload) {
      let startD = state.datetime;
      let endD = moment(startD, 'DD-MM-YYYY HH:mm');
      let mt_length = '';
      let lang = state.selectedLang;
      let venue_id = state.venueInfo.id;

      if(state.meeting_length == 'overnight'){
        mt_length = 24;
      } else if(state.meeting_length == 'twodays'){
        mt_length = 36;
      } else {
        mt_length = parseInt(state.meeting_length)
      }

      endD = endD.add(mt_length, 'hours')
      endD = endD.format('DD-MM-YYYY HH:mm') // End date ( including time)
      let discount_code = state.discount_code
      commit('roomsReady', false)
      return new Promise((resolve, reject) => {
        let _payload = {
          venue_id: venue_id,
          startDateTime: payload.startDateTime ? payload.startDateTime : startD,
          endDateTime: payload.endDateTime ? payload.endDateTime : endD,
          startD: payload.startDateTime ? payload.startDateTime : startD,
          lang: lang,
          delegates: payload.delegates ? payload.delegates : state.delegates,
          checkAvail: payload.checkAvail ? payload.checkAvail : '',
          checkAvailandPrices: payload.checkAvailandPrices
            ? payload.checkAvailandPrices
            : '',
          discount_code: discount_code,
          day: payload.day ? payload.day : 1,
          mt_length: payload.mt_length ? payload.mt_length : mt_length
        }

        Vue.http.post(state.baseUrl + '/' + 'apiv2/all-room-info', _payload).then(
          response => {
            commit('roomsReady', true)
            let _response = {
              mt_length: payload.mt_length ? payload.mt_length : mt_length,
              room_result: response
            }
            let isNCHEnquiry = response.body.enquiry ? true : false
            commit('setNCHEnquiry', isNCHEnquiry)
            resolve(_response)
          },
          response => {}
        )
      })
    },
    fetchMPPackages({ dispatch, commit, state }, payload) {
      let startD = state.datetime
      let endD = moment(startD, 'DD-MM-YYYY HH:mm')
      let mt_length = ''
      let lang = state.selectedLang
      let venue_id = state.venueInfo.id

      if (state.meeting_length == 'overnight') {
        mt_length = 24
      } else if (state.meeting_length == 'twodays') {
        mt_length = 36
      } else {
        mt_length = parseInt(state.meeting_length)
      }

      endD = endD.add(mt_length, 'hours')
      endD = endD.format('DD-MM-YYYY HH:mm') // End date ( including time)

      let discount_code = state.discount_code
      return new Promise((resolve, reject) => {
        let _payload = {
          venue_id: venue_id,
          startDateTime: startD,
          endDateTime: endD,
          startD: startD,
          lang: lang,
          discount_code: discount_code,
          delegates: state.delegates
        }

        Vue.http.post(state.baseUrl + '/' + 'apiv2/all-package-info', _payload).then(
          response => {
            let _response = {
              mt_length: mt_length,
              package_result: response
            }
            resolve(_response)
          },
          response => {}
        )
      })
    },
    async getRoom({ dispatch, commit, state }, data) {
      let payload = {}
      let mt_length
      if (state.isMoreThanOneDay) {
        payload = {
          day: 1,
          startDateTime: state.date + ' ' + state.defaultStartTime,
          endDateTime: state.date + ' ' + state.defaultEndTime,
          mt_length: 8
        }
      } else {
        if(state.meeting_length == 'overnight'){
          mt_length = 24;
        } else if(state.meeting_length == 'twodays'){
          mt_length = 36;
        } else {
          mt_length = parseInt(state.meeting_length)
        }
      }

      let venue_id = state.venueInfo.id;
      if(venue_id){
        let response, returnedEvent
        let room_result = []
        let packages = []

        if (data.useNewAPI) {
          returnedEvent = data.meeting_rooms
          room_result = data.meeting_rooms.roomList
          packages = data.packages
          commit('roomsReady', true)
        } else {
          response = await dispatch('fetchMPRooms', payload)
          returnedEvent = response.room_result.body
          room_result = response.room_result.body.roomList
          mt_length = response.mt_length
        }

        // dispatch('fetchMPRooms', payload).then(response => {
          if (state.isMoreThanOneDay) {
            // returnedEvent = response.room_result.body
            // mt_length = response.mt_length
            let roomList = returnedEvent.roomList
            let eventDay = returnedEvent.day
            let finalEvents = []
  
            roomList = hf.sortRoomList(roomList, state.delegates, mt_length, state.discount_code)
  
            finalEvents.push({
              day: eventDay,
              finalList: roomList,
              selected_room: roomList.length > 0 ? roomList[0].id : '',
              date: state.date,
              start_time: state.defaultStartTime,
              end_time: state.defaultEndTime,
              delegates: state.delegates,
              isChosen: 0
            })
  
            commit('setEventList', finalEvents)
  
            /*let payload = {
              date: state.date,
              startTime: state.defaultStartTime,
              endTime: state.defaultEndTime,
              day: 1
            };
      
            dispatch("checkBizHours", payload);*/
  
            commit('roomsReady', true)
          } else {
            // let room_result = response.room_result.body.roomList
            // mt_length = response.mt_length
            let IBRooms = []
            let roomList = hf.sortRoomList(
              room_result,
              state.delegates,
              mt_length,
              packages,
              state.discount_code
            )
            // After get the final room list, mutate some states.
            commit('setRoomInfo', roomList)
            commit('setSelectedRoom', roomList[0]?.id)
            if (!state.isRegus){
              commit('setLayoutsInRoom', roomList[0]?.id)
            }
            else {
              if (roomList.length === 0)
                commit('setRegusNoRoom', true)
              else {
                commit('setRegusNoRoom', false)
                commit('setRegusRoomInfo', roomList)
                commit('setRegusSelectedRoom', roomList[0]?.id)
                commit('setRegusLayoutsInRoom', {
                  room_id: roomList[0]?.id,
                  room_layout: roomList[0]?.room_layout
                })
              }
            }
  
            let selectedRoom = roomList[0]?.id
            let price = ''
            let selectedPrice = ''
            let selectedPrice_decimal = ''
  
            roomList.forEach(element => {
              if (element.id == selectedRoom) {
                if (!state.isRegus) {
                  switch (element.chosen_price) {
                    case 'normal':
                      price = element.calculated_prices?.price_vat / 100
                      state.roomBookingType = 'hourly'
                      break
                    case 'halfday':
                      price = element.calculated_prices?.halfday_price / 100
                      state.roomBookingType = 'half_day'
                      break
                    case 'fullday':
                      price = element.calculated_prices?.fullday_price / 100
                      state.roomBookingType = 'full_day'
                      break
                    default:
                      price = element.calculated_prices?.price_vat / 100
                      break
                  }
                } else {
                  price = element.correct_price.price / 100
                }

                let tempPrice = ''
                if (element.chosen_price == 'normal') {
                  tempPrice = (
                    parseFloat(price * mt_length) / state.delegates
                  ).toFixed(2)
                } else {
                  tempPrice = (parseFloat(price) / state.delegates).toFixed(2)
                }
  
                price = parseFloat(price).toFixed(2)
                selectedPrice = tempPrice.toString().split('.')[0]
                selectedPrice_decimal =
                  typeof tempPrice.toString().split('.')[1] == 'undefined'
                    ? '00'
                    : tempPrice.toString().split('.')[1]
  
                commit('setSelectedPrice', {
                  price,
                  selectedPrice,
                  selectedPrice_decimal
                })
              }
              if (element.instant_bookable == '1') {
                IBRooms.push(element.id)
              }
            })
            commit('setIBRooms', IBRooms)
            commit('roomsLoaded')
          }
        // })
      }
    },
    getRoomForEachDay({ dispatch, commit, state }, data) {
      let eventStartDate = data.date
      let eventStartTime = data.startTime
      let eventEndTime = data.endTime
      let day = data.day
      let delegates = data.delegates
      let startD = moment(
        eventStartDate + ' ' + eventStartTime,
        'DD-MM-YYYY HH:mm'
      )
      let endD = moment(eventStartDate + ' ' + eventEndTime, 'DD-MM-YYYY HH:mm')

      let duration = moment.duration(endD.diff(startD))
      let mt_length = parseInt(duration.asHours())

      let payload = {
        day: day,
        delegates: delegates,
        startDateTime: eventStartDate + ' ' + eventStartTime,
        endDateTime: eventStartDate + ' ' + eventEndTime,
        mt_length: mt_length
      }

      dispatch('fetchMPRooms', payload).then(response => {
        let _event = state.eventList
        let returnedEvent = response.room_result.body
        let roomList = returnedEvent.roomList
        let eventDay = returnedEvent.day

        _event.forEach(event_el => {
          if (eventDay == parseInt(event_el.day)) {
            roomList = hf.sortRoomList(roomList, delegates, mt_length)
            event_el.finalList = roomList
            event_el.selected_room =
              event_el.finalList.length > 0 ? event_el.finalList[0].id : ''
          }
        })
        commit('setEventList', _event)
        commit('roomsReady', true)
        commit('setTabIndex', parseInt(day))
      })
    },
    getRoomRegus({ commit, state }, data) {
      let regus_centre_id = window.regus_id ? JSON.parse(window.regus_id) : ''
      let bookingDateTime = state.datetime
      bookingDateTime = moment(bookingDateTime, 'DD-MM-YYYY HH:mm')
      let mt_length = ''

      let startDate = bookingDateTime.format('YYYY-MM-DD')
      let startTime = bookingDateTime.format('HH:mm')

      if (state.meeting_length == 'overnight') {
        mt_length = 24
      } else if (state.meeting_length == 'twodays') {
        mt_length = 36
      } else {
        mt_length = parseInt(state.meeting_length)
      }

      let endTime = bookingDateTime.add(mt_length, 'hours')
      endTime = bookingDateTime.format('HH:mm')

      return new Promise((resolve, reject) => {
        Vue.http
          .post(state.baseUrl + '/' + 'apiv2/regus/search', {
            venue_id: state.venueInfo.id,
            centre_id: regus_centre_id,
            booking_date: startDate,
            delegates: state.delegates,
            start_time: startTime,
            end_time: endTime
          })
          .then(response => {
            let result_count = 0
            if (
              response.body.SearchResponse &&
              response.body.SearchResponse.SearchResult['@attributes']
            ) {
              result_count = parseInt(
                response.body.SearchResponse.SearchResult['@attributes']
                  .SearchResultCount
              )
            }

            let room_list = []
            if (result_count > 0) {
              // Format Regus info to MeetingPackage structure.
              let room_result =
                response.body.SearchResponse.SearchResult.SearchResults
                  .SearchResult
              if (room_result['@attributes']) {
                // Only 1 room.
                let room_item = {
                  id: room_result['@attributes'].SearchResultID,
                  min: '',
                  max: room_result['@attributes'].Delegates,
                  title: hf.getRoomType(room_result['@attributes'].RoomTypeID),
                  room_layout: hf.getRoomConfiguration(
                    room_result['@attributes'].ConfigurationID
                  ),
                  vat_price: parseFloat(
                    room_result.InventoryPrice['@attributes'].AmountIncTax
                  ).toFixed(2),
                  no_vat_price: parseFloat(
                    room_result.InventoryPrice['@attributes'].AmountExTax
                  ).toFixed(2),
                  room_pictures: state.venueInfo.regus_image
                }
                room_list.push(room_item)
              } else {
                // Several rooms.
                room_result.forEach(element => {
                  let room_item = {
                    id: element['@attributes'].SearchResultID,
                    min: '',
                    max: element['@attributes'].Delegates,
                    room_pictures: state.venueInfo.regus_image,
                    title: hf.getRoomType(element['@attributes'].RoomTypeID),
                    room_layout: hf.getRoomConfiguration(
                      element['@attributes'].ConfigurationID
                    ),
                    vat_price: parseFloat(
                      element.InventoryPrice['@attributes'].AmountIncTax
                    ).toFixed(2),
                    no_vat_price: parseFloat(
                      element.InventoryPrice['@attributes'].AmountExTax
                    ).toFixed(2)
                  }
                  room_list.push(room_item)
                })
              }
              commit('setRegusNoRoom', false)
            } else {
              // Display the no room thing.
              commit('setRegusNoRoom', true)
            }

            if (result_count > 0) {
              // After get the final room list, mutate some states.
              commit('setRegusRoomInfo', room_list)
              commit('setRegusSelectedRoom', room_list[0].id)
              commit('setRegusLayoutsInRoom', {
                room_id: room_list[0].id,
                room_layout: room_list[0].room_layout
              })

              // Set Price
              let selectedRoom = room_list[0].id
              room_list.forEach(element => {
                if (element.id == selectedRoom) {
                  let tempPrice = (
                    parseFloat(element.vat_price) / state.delegates
                  ).toFixed(2)

                  let price = parseFloat(element.vat_price).toFixed(2)
                  let selectedPrice = tempPrice.toString().split('.')[0]
                  let selectedPrice_decimal =
                    typeof tempPrice.toString().split('.')[1] == 'undefined'
                      ? '00'
                      : tempPrice.toString().split('.')[1]

                  commit('setSelectedPrice', {
                    price,
                    selectedPrice,
                    selectedPrice_decimal
                  })
                }
              })
            }
          })
      })
    },
    changeRoomRegus({ commit, state }, data) {
      commit('setRegusSelectedRoom', data.id)
      commit('setRegusLayoutsInRoom', {
        room_id: data.id,
        room_layout: data.room_layout
      })

      // Set Price
      let selectedRoom = data.id
      let room_list = state.regusRoomInfo
      room_list.forEach(element => {
        if (element.id == selectedRoom) {
          let tempPrice, price
          if (!state.useNewVenuePage) { // Old venue page 
            tempPrice = (
              parseFloat(element.vat_price) / state.delegates
            ).toFixed(2)
            price = parseFloat(element.vat_price).toFixed(2)
          } else { // New Venue page
            tempPrice = (
              parseFloat(element.correct_price.price / 100) / state.delegates
            ).toFixed(2)
            price = parseFloat(element.correct_price.price / 100).toFixed(2)
          }

          let selectedPrice = tempPrice.toString().split('.')[0]
          let selectedPrice_decimal =
            typeof tempPrice.toString().split('.')[1] == 'undefined'
              ? '00'
              : tempPrice.toString().split('.')[1]

          commit('setSelectedPrice', {
            price,
            selectedPrice,
            selectedPrice_decimal
          })
        }
      })
    },
    getRoomOpera({ dispatch, commit, state }, data) {
      let events = []
      commit('resetEventLists')
      let venueID = state.venueInfo.id
      let timeStart = state.defaultStartTime
      let timeEnd = state.defaultEndTime
      let mt_length = ''
      let lang = state.selectedLang == 'en' ? '' : state.selectedLang
      let startTime = state.datetime.split(' ')[1]
      let endTime = ''
      if (state.meeting_length == 'overnight') {
        mt_length = 24
      } else if (state.meeting_length == 'twodays') {
        mt_length = 36
      } else {
        mt_length = parseInt(state.meeting_length)
      }

      if (state.isMoreThanOneDay) {
        let eventStartDate = moment(state.date, 'DD-MM-YYYY')
        let eventStartDateWithTime = moment(
          state.date + ' ' + timeStart,
          'DD-MM-YYYY HH:mm'
        )
        let eventEndDate = moment(state.end_date, 'DD-MM-YYYY')
        /*let numberOfDays = eventEndDate.diff(eventStartDate, 'days');
        for (let i = 0; i <= numberOfDays; i++) {
          let tempStartDate = eventStartDateWithTime.format('DD-MM-YYYY HH:mm');
          tempStartDate = moment(tempStartDate, 'DD-MM-YYYY HH:mm').add(i, 'days');
          let eventItem = {
            'start_date' : tempStartDate.format('YYYY-MM-DDTHH:mm:ss'),
            'end_date' : tempStartDate.format('YYYY-MM-DDT') + timeEnd + ':00',
            'startDateTime' : tempStartDate.format('DD-MM-YYYY HH:mm'),
            'endDateTime' : tempStartDate.format('DD-MM-YYYY') + ' ' + timeEnd,
          };
          events.push(eventItem);
        }*/
        let eventItem = {
          start_date: eventStartDateWithTime.format('YYYY-MM-DDTHH:mm:ss'),
          end_date:
            eventStartDateWithTime.format('YYYY-MM-DDT') + timeEnd + ':00',
          startDateTime: eventStartDateWithTime.format('DD-MM-YYYY HH:mm'),
          endDateTime:
            eventStartDateWithTime.format('DD-MM-YYYY') + ' ' + timeEnd
        }
        events.push(eventItem)
      } else {
        let startD = state.datetime
        let operaStartD = moment(startD, 'DD-MM-YYYY HH:mm')
        operaStartD = operaStartD.format('YYYY-MM-DDTHH:mm:ss')
        let endD = moment(startD, 'DD-MM-YYYY HH:mm')

        endD = endD.add(mt_length, 'hours')
        let operaEndD = endD
        endD = endD.format('DD-MM-YYYY HH:mm') // End date ( including time)
        endTime = endD.split(' ')[1]
        operaEndD = operaEndD.format('YYYY-MM-DDTHH:mm:ss')
        let eventItem = {
          start_date: operaStartD,
          end_date: operaEndD,
          startDateTime: startD,
          endDateTime: endD
        }
        events.push(eventItem)
      }

      let payload = {
        venueID: venueID,
        events: events
      }

      dispatch('fetchOperaRooms', payload).then(response => {
        if (state.isMoreThanOneDay) {
          let returnedEvents = response.body
          returnedEvents.forEach(event_el => {
            let _operaRooms = event_el.operaRooms
            let roomList = event_el.roomList
            let finalList = hf.sortRoomList(roomList, state.delegates, 8)

            /*let finalList = hf.mergeAndSortOperaList(
              roomList,
              _operaRooms,
              timeStart,
              timeEnd,
              state,
              '8'
            )*/

            event_el.finalList = finalList
            event_el.mt_length = 8;
            // Set some stuff.
            event_el.selected_room =
              event_el.finalList.length > 0 ? event_el.finalList[0].id : ''
            event_el.date = state.date
            event_el.start_time = state.defaultStartTime
            event_el.end_time = state.defaultEndTime
            event_el.delegates = state.delegates
            event_el.isChosen = 0
          })
          commit('setEventList', returnedEvents)

          let payload = {
            date: state.date,
            startTime: state.defaultStartTime,
            endTime: state.defaultEndTime,
            day: 1
          }

          dispatch('checkBizHours', payload)

          commit('roomsReady', true)
        } else {
          // Normal
          let _operaRooms = response.body[0]?.operaRooms
          let roomList = response.body[0].roomList
          /*let roomList = hf.mergeAndSortOperaList(
            roomList,
            _operaRooms,
            startTime,
            endTime,
            state,
            mt_length
          )*/
          roomList = hf.sortRoomList(roomList, state.delegates, mt_length)
          commit('setRoomInfo', roomList)
          if (roomList[0] && roomList[0].id) {
            commit('setSelectedRoom', roomList[0].id)
            commit('setLayoutsInRoom', roomList[0].id)

            let selectedRoom = roomList[0].id
            let price = ''
            let selectedPrice = ''
            let selectedPrice_decimal = ''
            let IBRooms = []

            roomList.forEach(element => {
              if (element.id == selectedRoom) {
                switch (element.chosen_price) {
                  case 'normal':
                    price = element.calculated_prices.price_vat / 100
                    break
                  case 'halfday':
                    price = element.calculated_prices.halfday_price / 100
                    break
                  case 'fullday':
                    price = element.calculated_prices.fullday_price / 100
                    break
                  default:
                    price = element.calculated_prices.price_vat / 100
                    break
                }
                if(element.correct_price){
                  price = element.correct_price.price / 100
                }
                let tempPrice = ''
                if (element.chosen_price == 'normal') {
                  tempPrice = (
                    parseFloat(price * mt_length) / state.delegates
                  ).toFixed(2)
                } else {
                  tempPrice = (parseFloat(price) / state.delegates).toFixed(2)
                }

                price = parseFloat(price).toFixed(2)
                selectedPrice = tempPrice.toString().split('.')[0]
                selectedPrice_decimal =
                  typeof tempPrice.toString().split('.')[1] == 'undefined'
                    ? '00'
                    : tempPrice.toString().split('.')[1]

                commit('setSelectedPrice', {
                  price,
                  selectedPrice,
                  selectedPrice_decimal
                })
              }
              if (element.instant_bookable == '1') {
                IBRooms.push(element.id)
              }
            })
            commit('setIBRooms', IBRooms)
          }
          commit('roomsReady', true)
        }
      })

      //commit('setRoomList', room_list);
    },
    async getPackage({ dispatch, commit, state }, data) {
      let packages  = []
      if (data.useNewAPI) {
        packages = data.packages
      } else {
        let response = await dispatch('fetchMPPackages')
        packages = response.package_result.body
      }

        packages.forEach(element => {
          let count = 0
          let nonAvailCount = 0
          element.rooms.forEach(el => {
            if (el.available == 0) {
              nonAvailCount++
            }
            count++
          })
          if (count == nonAvailCount) {
            element.available = 0
          } else {
            element.available = 1
          }
        })
        // Sort packages.
        let packagesList = _.orderBy(
          packages,
          [
            // function (item) {
            //   // Sort by start time
            //   if (item.is_new) {
            //     let roomHireEvent = item.events.find(event => event.content_type == 'meetingroom')
            //     let startTime = roomHireEvent.start_time.replace(":",".")
            //     let selectedStartTime = state.time.replace(":",".")
                
            //     return Math.abs(parseFloat(startTime) - parseFloat(selectedStartTime))
            //   }
            //   return 0
            // },
            // function (item) {
            //   // Sort by end time
            //   if (item.is_new) {
            //     let roomHireEvent = item.events.find(event => event.content_type == 'meetingroom')
            //     let endTime = roomHireEvent.end_time.replace(":",".")
            //     let selectedEndTime = state.end_time.replace(":",".")
  
            //     return Math.abs(parseFloat(endTime) - parseFloat(selectedEndTime)) 
            //   }
            //   return 0
            // },
            function(item) {
              // Sort by room type first.
              let temp = ''
              switch (item.package_length) {
                case '4':
                  temp = 0
                  break
                case '8':
                  temp = 1
                  break
                case '24':
                  temp = 2
                  break
                case '36':
                  temp = 3
                  break
                  return temp
              }
              return temp
            },
            function(item) {
              // Sort by delegates
              let temp = ''
              if (parseInt(item.package_max) >= parseInt(state.delegates) && parseInt(item.package_min) <= parseInt(state.delegates)) {
                // need to check room here.
                let count = 0
                let unavailableRoomCount = 0
                item.rooms.forEach(el => {
                  if (
                    parseInt(el.max) < parseInt(state.delegates) ||
                    el.available == 0
                  ) {
                    unavailableRoomCount++
                  }
                  count++
                })
                if (count == unavailableRoomCount) {
                  item.allRoomUnavailable = 'yes'
                  item.exceed = 'no'
                  temp = 0
                } else {
                  item.allRoomUnavailable = 'no'
                  item.exceed = 'no'
                  temp = 1
                }
              } else {
                item.exceed = 'yes'
                temp = 0
              }
              return temp
            },
            function(item) {
              if(item.correct_price){
                // Sort by price.
                var correctDelegates =
                parseInt(item.package_min) > parseInt(state.delegates)
                  ? parseInt(item.package_min)
                  : parseInt(state.delegates)
                return (
                parseInt(item.correct_price.price) * correctDelegates ||
                Infinity
                )
              } 
              return 1
            }
          ],
          ['asc', 'desc', 'asc']
        )
        // End sort.
        commit('setPackageInfo', packagesList)
        commit('packagesLoaded')
        let pLength = ''

        switch (state.meeting_length.toString()) {
          case '2':
          case '3':
          case '4':
          case '5':
            pLength = 4
            break
          case '6':
          case '7':
          case '8':
          case '9':
          case '10':
            pLength = 8
            break
          case 'overnight':
            pLength = 24
            break
          case 'twodays':
            pLength = 36
            break
        }

        let selectedPackage = ''
        for (let element of packagesList) {
          if (parseInt(element.package_length) == pLength || element.is_new) {
            selectedPackage = element.id
            commit('setSelectedPackage', element.id)
            dispatch('sortRoomListinPackage', element.rooms)
            break
          }
        }

        let price = ''
        let selectedPrice = ''
        let selectedPrice_decimal = ''

        let allRoomsInPackages = []
        let IBRooms = []
        packagesList.forEach(element => {
          element.rooms.forEach(el => {
            allRoomsInPackages.push(el.id)
            if (el.instant_bookable == '1') {
              IBRooms.push(el.id)
            }
          })
          allRoomsInPackages = _.uniq(allRoomsInPackages)
          IBRooms = _.uniq(IBRooms)

          
        })
        commit('setIBRooms', IBRooms)
        commit('setAllRoomsInPackages', allRoomsInPackages)
        commit('packagesReady', true)
    },
    getOperaMenus({ dispatch, commit, state }, data) {
      return new Promise((resolve, reject) => {
        Vue.http
          .post(state.baseUrl + '/' + 'apiv2/opera/get-menus', {
            server: state.venueInfo.operaServer,
            chain_code: state.venueInfo.operaChainCode,
            hotel_code: state.venueInfo.operaHotelID
          })
          .then(response => {
            resolve(response)
          })
      })
    },
    getOperaMenuItems({ dispatch, commit, state }, data) {
      return new Promise((resolve, reject) => {
        Vue.http
          .post(state.baseUrl + '/' + 'apiv2/opera/get-menu-items', {
            server: state.venueInfo.operaServer,
            chain_code: state.venueInfo.operaChainCode,
            hotel_code: state.venueInfo.operaHotelID
          })
          .then(response => {
            resolve(response)
          })
      })
    },
    getOperaMiscItems({ dispatch, commit, state }, data) {
      let _start = data.start_date
      let _end = data.end_date
      return new Promise((resolve, reject) => {
        Vue.http
          .post(state.baseUrl + '/' + 'apiv2/opera/get-misc-items', {
            server: state.venueInfo.operaServer,
            chain_code: state.venueInfo.operaChainCode,
            hotel_code: state.venueInfo.operaHotelID,
            start: _start,
            end: _end
          })
          .then(response => {
            resolve(response)
          })
      })
    },
    getOperaPackage({ dispatch, commit, state }, data) {
      let events = []
      commit('resetEventLists')
      if (state.isMoreThanOneDay) {
        let timeStart = state.defaultStartTime
        let timeEnd = state.defaultEndTime
        let eventStartDate = moment(state.date, 'DD-MM-YYYY')
        let eventStartDateWithTime = moment(
          state.date + ' ' + timeStart,
          'DD-MM-YYYY HH:mm'
        )
        /*let eventEndDate = moment(state.end_date, 'DD-MM-YYYY');
        let numberOfDays = eventEndDate.diff(eventStartDate, 'days');
        for (let i = 0; i <= numberOfDays; i++) {
          let tempStartDate = eventStartDateWithTime.format('DD-MM-YYYY HH:mm');
          tempStartDate = moment(tempStartDate, 'DD-MM-YYYY HH:mm').add(i, 'days');
          let eventItem = {
            'start_date' : tempStartDate.format('YYYY-MM-DDTHH:mm:ss'),
            'end_date' : tempStartDate.format('YYYY-MM-DDT') + timeEnd + ':00',
            'startDateTime' : tempStartDate.format('DD-MM-YYYY HH:mm'),
            'endDateTime' : tempStartDate.format('DD-MM-YYYY') + ' ' + timeEnd,
          };
          events.push(eventItem);
        }*/
        let eventItem = {
          start_date: eventStartDateWithTime.format('YYYY-MM-DDTHH:mm:ss'),
          end_date:
            eventStartDateWithTime.format('YYYY-MM-DDT') + timeEnd + ':00',
          startDateTime: eventStartDateWithTime.format('DD-MM-YYYY HH:mm'),
          endDateTime:
            eventStartDateWithTime.format('DD-MM-YYYY') + ' ' + timeEnd
        }
        events.push(eventItem)
      } else {
        let startD = state.datetime
        let operaStartD = moment(startD, 'DD-MM-YYYY HH:mm')
        operaStartD = operaStartD.format('YYYY-MM-DDTHH:mm:ss')
        let endD = moment(startD, 'DD-MM-YYYY HH:mm')
        let mt_length = 8

        endD = endD.add(mt_length, 'hours')
        let operaEndD = endD
        endD = endD.format('DD-MM-YYYY HH:mm') // End date ( including time)
        let endTime = endD.split(' ')[1]
        operaEndD = operaEndD.format('YYYY-MM-DDTHH:mm:ss')
        let eventItem = {
          start_date: operaStartD,
          end_date: operaEndD,
          startDateTime: startD,
          endDateTime: endD
        }
        events.push(eventItem)
      }

      let payload = {
        venue_id: state.venueInfo.id,
        server: state.venueInfo.operaServer,
        chain_code: state.venueInfo.operaChainCode,
        hotel_code: state.venueInfo.operaHotelID,
        lang: state.selectedLang,
        delegates: state.delegates,
        events: events,
        code: state.discount_code
      }
      commit('setPackageInfo', [])
      dispatch('fetchOperaPackages', payload).then(response => {
        //console.log(response);
        if (state.isMoreThanOneDay) {
          let returnedEvents = response.body

          // Need to do some stuff here for event list.
          returnedEvents.forEach(event_el => {
            event_el.selected_package =
              event_el.packages.length > 0 ? event_el.packages[0].id : ''
            event_el.room_list_in_package =
              event_el.packages.length > 0 ? event_el.packages[0].rooms : ''
            event_el.selected_room_in_package =
              event_el.packages.length > 0 &&
              event_el.packages[0].rooms.length > 0
                ? event_el.packages[0].rooms[0].id
                : ''
            event_el.date = state.date
            event_el.start_time = state.defaultStartTime
            event_el.end_time = state.defaultEndTime
            event_el.delegates = state.delegates
            event_el.isChosen = 0

            event_el.packages.forEach(package_el => {
              let rooms = package_el.rooms
              rooms.forEach(room_el => {
                if (parseInt(event_el.delegates) > parseInt(room_el.max)) {
                  room_el.exceed = 'yes'
                } else {
                  room_el.exceed = 'no'
                }
                let selectedLayout = state.selectedLayoutinPackage
                let layout_object = room_el.room_layout
                let layout_code = hf.getLayoutCode(selectedLayout)
                room_el.valid_layout = false
                for (let layout in layout_object) {
                  if (
                    (layout == layout_code &&
                      parseInt(layout_object[layout]) >= state.delegates) ||
                    layout_code == '_none'
                  ) {
                    room_el.valid_layout = true
                  }
                }
                package_el.exceed = room_el.exceed // Because there's only 1 room.
                package_el.available = room_el.available
                package_el.allRoomUnavailable = room_el.available ? 'no' : 'yes'
                package_el.package_min = room_el.min
                package_el.package_max = room_el.max

                package_el.area = room_el.area
                package_el.length = room_el.length
                package_el.width = room_el.width
                package_el.height = room_el.height

                package_el.equipment_name = room_el.equipment_name
                package_el.equipment_fee_name = room_el.equipment_fee_name
                package_el.all_equipment = room_el.all_equipment

                package_el.instant_bookable = room_el.instant_bookable
                package_el.room_pictures = room_el.room_pictures
                package_el.valid_layout = room_el.valid_layout
              })
            })
          })
          commit('setEventList', returnedEvents)

          let payload = {
            date: state.date,
            startTime: state.defaultStartTime,
            endTime: state.defaultEndTime,
            day: 1
          }

          dispatch('checkBizHours', payload)

          commit('packagesReady', true)
        } else {
          let packagesList = []
          let packages = Array.isArray(response.body)
            ? response.body[0].packages
            : []

          if (
            packages != null &&
            packages != 'error' &&
            Array.isArray(packages)
          ) {
            packages.forEach(element => {
              let count = 0
              let nonAvailCount = 0
              element.rooms.forEach(el => {
                if (el.available == 0) {
                  nonAvailCount++
                }
                // Set min max for Package from Room min max
                element.package_min = el.min
                element.package_max = el.max

                element.area = el.area
                element.length = el.length
                element.width = el.width
                element.height = el.height

                element.equipment_name = el.equipment_name
                element.equipment_fee_name = el.equipment_fee_name
                element.all_equipment = el.all_equipment

                element.instant_bookable = el.instant_bookable
                element.room_pictures = el.room_pictures
                element.valid_layout = el.valid_layout
                count++
              })
              if (count == nonAvailCount) {
                element.available = 0
                element.allRoomUnavailable = 'yes'
              } else {
                element.available = 1
                element.allRoomUnavailable = 'no'
              }
            })

            // Sort packages.
            packagesList = _.orderBy(
              packages,
              [
                function(item) {
                  return item.available
                },
                function(item) {
                  // Sort by price.
                  return parseInt(item.calculated_prices.price_vat) || Infinity
                }
              ],
              ['desc', 'asc']
            )
            // End sort.

            commit('setPackageInfo', packagesList)
            commit('packagesLoaded')

            let selectedPackage = ''
            for (let element of packagesList) {
              selectedPackage = element.id
              commit('setSelectedPackage', element.id)
              dispatch('sortRoomListinPackage', element.rooms)
              commit('setSelectedLayoutinPackage', element.selected_layout)
              break
            }

            let price = ''
            let selectedPrice = ''
            let selectedPrice_decimal = ''

            let allRoomsInPackages = []
            let IBRooms = []
            packagesList.forEach(element => {
              element.rooms.forEach(el => {
                allRoomsInPackages.push(el.id)
                if (el.instant_bookable == '1') {
                  IBRooms.push(el.id)
                }
              })
              allRoomsInPackages = _.uniq(allRoomsInPackages)
              IBRooms = _.uniq(IBRooms)

              if (element.id == selectedPackage) {
                price = element.calculated_prices.price_vat / 100
                price = parseFloat(price).toFixed(2)
                selectedPrice = price.toString().split('.')[0]
                selectedPrice_decimal =
                  typeof price.toString().split('.')[1] == 'undefined'
                    ? '00'
                    : price.toString().split('.')[1]

                commit('setSelectedPrice', {
                  price,
                  selectedPrice,
                  selectedPrice_decimal
                })
              }
            })
            commit('setIBRooms', IBRooms)
            commit('setAllRoomsInPackages', allRoomsInPackages)
          } else {
            commit('setPackageInfo', packagesList)
          }
          commit('packagesReady', true)
        }
      })
    },
    getOperaPackageForEachDay({ dispatch, commit, state }, data) {
      // Only used in multidays.
      let events = []
      let eventStartDate = data.date
      let eventStartTime = data.startTime
      let eventEndTime = data.endTime
      let day = data.day
      let startD_m = moment(
        eventStartDate + ' ' + eventStartTime,
        'DD-MM-YYYY HH:mm'
      )
      let endD_m = moment(
        eventStartDate + ' ' + eventEndTime,
        'DD-MM-YYYY HH:mm'
      )

      let startD = startD_m.format('DD-MM-YYYY HH:mm')
      let endD = endD_m.format('DD-MM-YYYY HH:mm')
      let operaStartD = startD_m.format('YYYY-MM-DDTHH:mm:ss')
      let operaEndD = endD_m.format('YYYY-MM-DDTHH:mm:ss')
      let eventItem = {
        start_date: operaStartD,
        end_date: operaEndD,
        startDateTime: startD,
        endDateTime: endD
      }
      events.push(eventItem)

      let payload = {
        venue_id: state.venueInfo.id,
        server: state.venueInfo.operaServer,
        chain_code: state.venueInfo.operaChainCode,
        hotel_code: state.venueInfo.operaHotelID,
        lang: state.selectedLang,
        delegates: data.delegates,
        events: events,
        day: day,
        code: state.discount_code
      }

      dispatch('fetchOperaPackages', payload).then(response => {
        let _event = state.eventList
        let _packages = Array.isArray(response.body)
          ? response.body[0].packages
          : []
        _event.forEach(event_el => {
          if (day == parseInt(event_el.day)) {
            event_el.selected_package =
              _packages.length > 0 ? _packages[0].id : ''
            event_el.room_list_in_package =
              _packages.length > 0 ? _packages[0].rooms : ''
            event_el.selected_room_in_package =
              _packages.length > 0 && _packages[0].rooms.length > 0
                ? _packages[0].rooms[0].id
                : ''
            event_el.packages = _packages
            event_el.packages.forEach(package_el => {
              let rooms = package_el.rooms
              rooms.forEach(room_el => {
                if (parseInt(data.delegates) > parseInt(room_el.max)) {
                  room_el.exceed = 'yes'
                } else {
                  room_el.exceed = 'no'
                }
                package_el.exceed = room_el.exceed // Because there's only 1 room.
                package_el.available = room_el.available
                package_el.allRoomUnavailable = room_el.available ? 'no' : 'yes'

                package_el.package_min = room_el.min
                package_el.package_max = room_el.max

                package_el.area = room_el.area
                package_el.length = room_el.length
                package_el.width = room_el.width
                package_el.height = room_el.height

                package_el.equipment_name = room_el.equipment_name
                package_el.equipment_fee_name = room_el.equipment_fee_name
                package_el.all_equipment = room_el.all_equipment

                package_el.instant_bookable = room_el.instant_bookable
                package_el.room_pictures = room_el.room_pictures
                package_el.valid_layout = room_el.valid_layout
              })
            })
            // Sort packages.
            event_el.packages = _.orderBy(
              event_el.packages,
              [
                function(item) {
                  return item.available
                },
                function(item) {
                  // Sort by price.
                  return parseInt(item.calculated_prices.price_vat) || Infinity
                }
              ],
              ['desc', 'asc']
            )
            // End sort.
          }
        })
        //console.log(_event);
        commit('setEventList', _event)
        commit('packagesReady', true)
        commit('setTabIndex', parseInt(day))
      })
    },
    getOperaRoomForEachDay({ dispatch, commit, state }, data) {
      let events = []
      let eventStartDate = data.date
      let eventStartTime = data.startTime
      let eventEndTime = data.endTime
      let day = data.day
      let delegates = data.delegates
      let startD_m = moment(
        eventStartDate + ' ' + eventStartTime,
        'DD-MM-YYYY HH:mm'
      )
      let endD_m = moment(
        eventStartDate + ' ' + eventEndTime,
        'DD-MM-YYYY HH:mm'
      )

      let duration = moment.duration(endD_m.diff(startD_m))
      let mt_length = parseInt(duration.asHours())

      let startD = startD_m.format('DD-MM-YYYY HH:mm')
      let endD = endD_m.format('DD-MM-YYYY HH:mm')
      let operaStartD = startD_m.format('YYYY-MM-DDTHH:mm:ss')
      let operaEndD = endD_m.format('YYYY-MM-DDTHH:mm:ss')
      let eventItem = {
        start_date: operaStartD,
        end_date: operaEndD,
        startDateTime: startD,
        endDateTime: endD
      }
      events.push(eventItem)

      let payload = {
        venueID: state.venueInfo.id,
        events: events,
        day: day,
        delegates: delegates
      }

      dispatch('fetchOperaRooms', payload).then(response => {
        let _event = state.eventList
        let _operaRooms = response.body[0].operaRooms
        let roomList = response.body[0].roomList
        _event.forEach(event_el => {
          if (day == parseInt(event_el.day)) {
            /*let finalList = hf.mergeAndSortOperaList(
              roomList,
              _operaRooms,
              event_el.start_time,
              event_el.end_time,
              state,
              mt_length
            )*/
            let finalList = hf.sortRoomList(roomList, delegates, mt_length)

            event_el.finalList = finalList
            event_el.mt_length = mt_length;
            // Set some stuff.
            event_el.selected_room =
              event_el.finalList.length > 0 ? event_el.finalList[0].id : ''
          }
        })
        commit('setEventList', _event)
        commit('roomsReady', true)
        commit('setTabIndex', parseInt(day))
      })
    },
    fetchOperaPackages({commit, state}, payload){
      if (payload.venue_id){
        return new Promise((resolve,reject) => {
          commit('packagesReady', false);
          Vue.http.post(state.baseUrl + '/' + 'apiv2/opera/get-meeting-package-availability', payload ).then(response => {
            resolve(response);
            }, response => {
          });
        });
      }
    },
    fetchAllRoomIDsInVenue({commit, state}, payload){
      return new Promise((resolve,reject) => {
        Vue.http.get(state.baseUrl + '/' + 'apiv2/ompa_room/' + payload.venueID).then(response => {
          resolve(response);
          }, response => {
        });
      });
    },
    resendVerification({commit, state}, email){
      let payload = {'email': email, 'resend':true, 'lang': state.selectedLang};
      return new Promise((resolve,reject) => {
        Vue.http.post(state.baseUrl + '/' + 'apiv2/email/send', payload).then(response => {
          resolve(response);
          }, response => {
        });
      });
    },
    fetchAllRoomInfoInVenue({commit, state}, payload){ // Probably Old Function
      let startD = state.datetime;
      let endD = moment(startD, 'DD-MM-YYYY HH:mm');
      let mt_length = '';
      if(state.meeting_length == 'overnight'){ 
        mt_length = 24;
      } else if(state.meeting_length == 'twodays'){
        mt_length = 36;
      } else {
        mt_length = parseInt(state.meeting_length)
      }
      endD = endD.add(mt_length, 'hours')
      endD = endD.format('DD-MM-YYYY HH:mm')

      return new Promise((resolve, reject) => {
        Vue.http
          .post(state.baseUrl + '/' + 'apiv2/all-room-info', {
            room_ids: payload.room_list,
            startDateTime: startD,
            endDateTime: endD,
            startD: startD,
            lang: state.selectedLang
          })
          .then(
            response => {
              resolve(response)
            },
            response => {}
          )
      })
    },
    fetchOperaRooms({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        commit('roomsReady', false)
        let _payload = {
          server: state.venueInfo.operaServer,
          delegates: payload.delegates ? payload.delegates : state.delegates,
          chain_code: state.venueInfo.operaChainCode,
          hotel_code: state.venueInfo.operaHotelID,
          lang: state.selectedLang,
          events: payload.events,
          venue_id: payload.venueID,
          day: payload.day,
          code: state.discount_code
        }

        Vue.http.post(state.baseUrl + '/' + 'apiv2/opera/get-meeting-availability', _payload).then(
          response => {
            resolve(response)
          },
          response => {}
        )
      })
    },
    sortRoomList({ commit, state }, payload) {

      let mt_length = state.meeting_length
      let delegates = state.delegates
      let roomList = ''
      if (payload) {
        roomList = payload.mergedList
      } else {
        roomList = state.roomInfo
      }
      if(!Array.isArray(roomList) || roomList.length == 0){
        return;
      }
      // Get min delegates from room list.
      let roomMinArr = []
      roomList.forEach(el => {
        if (parseInt(el.available) == 1) {
          roomMinArr.push(el.min)
        }
      })

      let minNum = _.min(roomMinArr)
      commit('setMinRoomNumber', minNum)
      let newlist = []
      if (state.isBE) {
        newlist = _.orderBy(
          roomList,
          [
            function(item) {
              // Sort by availablity first. Available rooms will be first then to non-available rooms.
              return item.available
            },
            function(item) {
              // Sort by delegates
              let temp = ''
              if (parseInt(item.max) >= parseInt(delegates)) {
                item.exceed = 'no'
                temp = 1
              } else {
                item.exceed = 'yes'
                temp = 0
              }
              return temp
            },
            function(item) {
              // Invalid Layout.
              let selectedLayout = state.selectedLayout
              let layout_object = item.room_layout
              let layout_code = hf.getLayoutCode(selectedLayout)
              item.valid_layout = false
              let temp = 0
              for (let layout in layout_object) {
                if (
                  (layout == layout_code &&
                    parseInt(layout_object[layout]) >= state.delegates) ||
                  layout_code == '_none'
                ) {
                  item.valid_layout = true
                  temp = 1
                }
              }
              return temp
            },
            function(item) {
              // Sort by instant bookable later. Instant bookable rooms will be first then to non-instant bookale room.
              return item.instant_bookable
            },
            function(item) {
              // Crazy stuff for sorting rooms based on prices.
              if(item.correct_price){
                let price = '';
                switch (item.correct_price.type) {
                  case 'hourly':
                    item.chosen_price = 'normal';
                    price = parseFloat(item.correct_price.price) / 100;
                    break;
                  case 'halfday':
                    item.chosen_price = 'halfday';
                    price = parseFloat(item.correct_price.price) / mt_length / 100;
                    break;
                  case 'fullday':
                    item.chosen_price = 'fullday';
                    price = parseFloat(item.correct_price.price) / mt_length / 100;
                    break;
                  default:
                    break;
                }

                return price || Infinity;
              } else {
                if (item.calculated_prices.price_vat > 0) {
                  switch (mt_length.toString()) {
                    case '2':
                    case '3':
                    case '4':
                    case '5':
                      if (item.calculated_prices.halfday_price > 0) {
                        let room_price_vat =
                          parseFloat(item.calculated_prices.halfday_price) /
                          mt_length /
                          100
                        item.chosen_price = 'halfday'
                        item.what = room_price_vat
                        return room_price_vat
                      } else {
                        let room_price_vat =
                          parseFloat(item.calculated_prices.price_vat) / 100
                        if (item.calculated_prices.isOperaPrice) {
                          item.chosen_price = 'opera'
                        } else {
                          item.chosen_price = 'normal'
                        }
                        item.what = room_price_vat
                        return room_price_vat
                      }
                      break
                    case '6':
                    case '7':
                    case '8':
                    case '9':
                    case '10':
                      if (item.calculated_prices.fullday_price > 0) {
                        let room_price_vat =
                          parseFloat(item.calculated_prices.fullday_price) /
                          mt_length /
                          100
                        item.chosen_price = 'fullday'
                        item.what = room_price_vat
                        return room_price_vat
                      } else {
                        let room_price_vat =
                          parseFloat(item.calculated_prices.price_vat) / 100
                        if (item.calculated_prices.isOperaPrice) {
                          item.chosen_price = 'opera'
                        } else {
                          item.chosen_price = 'normal'
                        }
                        item.what = room_price_vat
                        return room_price_vat
                      }
                      break
                    default:
                      let room_price_vat =
                        parseFloat(item.calculated_prices.price_vat) / 100
                      if (item.calculated_prices.isOperaPrice) {
                        item.chosen_price = 'opera'
                      } else {
                        item.chosen_price = 'normal'
                      }
                      item.what = room_price_vat
                      return room_price_vat
                  }
                } else {
                  // If there is no price for hourly.
                  switch (mt_length.toString()) {
                    case '2':
                    case '3':
                    case '4':
                    case '5':
                      if (item.calculated_prices.halfday_price > 0) {
                        let room_price_vat =
                          parseFloat(item.calculated_prices.halfday_price) /
                          mt_length /
                          100
                        item.chosen_price = 'halfday'
                        item.what = room_price_vat
                        return room_price_vat
                      } else if (item.calculated_prices.fullday_price > 0) {
                        let room_price_vat =
                          parseFloat(item.calculated_prices.fullday_price) /
                          mt_length /
                          100
                        item.chosen_price = 'fullday'
                        item.what = room_price_vat
                        return room_price_vat
                      } else {
                        item.chosen_price = 'none'
                        return (
                          parseFloat(item.calculated_prices.price_vat) || Infinity
                        )
                      }
                      break
                    case '6':
                    case '7':
                    case '8':
                    case '9':
                    case '10':
                      if (item.calculated_prices.fullday_price > 0) {
                        let room_price_vat =
                          parseFloat(item.calculated_prices.fullday_price) /
                          mt_length /
                          100
                        item.chosen_price = 'fullday'
                        item.what = room_price_vat
                        return room_price_vat
                      } else {
                        item.chosen_price = 'none'
                        return (
                          parseFloat(item.calculated_prices.price_vat) || Infinity
                        )
                      }
                      break
                    default:
                      item.chosen_price = 'none'
                      return (
                        parseFloat(item.calculated_prices.price_vat) || Infinity
                      ) // Infinity to put the rooms without prices to bottom.
                  }
                }
              }

            }
          ],
          ['desc', 'desc', 'desc', 'desc', 'asc']
        )
      } else {
        newlist = _.orderBy(
          roomList,
          [
            function(item) {
              // Sort by availablity first. Available rooms will be first then to non-available rooms.
              return item.available
            },
            function(item) {
              // Sort by delegates
              let temp = ''
              if (parseInt(item.max) >= parseInt(delegates)) {
                item.exceed = 'no'
                temp = 1
              } else {
                item.exceed = 'yes'
                temp = 0
              }
              return temp
            },
            function(item) {
              // Sort by instant bookable later. Instant bookable rooms will be first then to non-instant bookale room.
              return item.instant_bookable
            },
            function(item) {
              // Crazy stuff for sorting rooms based on prices.
              if (item.calculated_prices.price_vat > 0) {
                switch (mt_length.toString()) {
                  case '2':
                  case '3':
                  case '4':
                  case '5':
                    if (item.calculated_prices.halfday_price > 0) {
                      let room_price_vat =
                        parseFloat(item.calculated_prices.halfday_price) /
                        mt_length /
                        100
                      item.chosen_price = 'halfday'
                      item.what = room_price_vat
                      return room_price_vat
                    } else {
                      let room_price_vat =
                        parseFloat(item.calculated_prices.price_vat) / 100
                      if (item.calculated_prices.isOperaPrice) {
                        item.chosen_price = 'opera'
                      } else {
                        item.chosen_price = 'normal'
                      }
                      item.what = room_price_vat
                      return room_price_vat
                    }
                    break
                  case '6':
                  case '7':
                  case '8':
                  case '9':
                  case '10':
                    if (item.calculated_prices.fullday_price > 0) {
                      let room_price_vat =
                        parseFloat(item.calculated_prices.fullday_price) /
                        mt_length /
                        100
                      item.chosen_price = 'fullday'
                      item.what = room_price_vat
                      return room_price_vat
                    } else {
                      let room_price_vat =
                        parseFloat(item.calculated_prices.price_vat) / 100
                      if (item.calculated_prices.isOperaPrice) {
                        item.chosen_price = 'opera'
                      } else {
                        item.chosen_price = 'normal'
                      }
                      item.what = room_price_vat
                      return room_price_vat
                    }
                    break
                  default:
                    let room_price_vat =
                      parseFloat(item.calculated_prices.price_vat) / 100
                    if (item.calculated_prices.isOperaPrice) {
                      item.chosen_price = 'opera'
                    } else {
                      item.chosen_price = 'normal'
                    }
                    item.what = room_price_vat
                    return room_price_vat
                }
              } else {
                // If there is no price for hourly.
                switch (mt_length.toString()) {
                  case '2':
                  case '3':
                  case '4':
                  case '5':
                    if (item.calculated_prices.halfday_price > 0) {
                      let room_price_vat =
                        parseFloat(item.calculated_prices.halfday_price) /
                        mt_length /
                        100
                      item.chosen_price = 'halfday'
                      item.what = room_price_vat
                      return room_price_vat
                    } else if (item.calculated_prices.fullday_price > 0) {
                      let room_price_vat =
                        parseFloat(item.calculated_prices.fullday_price) /
                        mt_length /
                        100
                      item.chosen_price = 'fullday'
                      item.what = room_price_vat
                      return room_price_vat
                    } else {
                      item.chosen_price = 'none'
                      return (
                        parseFloat(item.calculated_prices.price_vat) || Infinity
                      )
                    }
                    break
                  case '6':
                  case '7':
                  case '8':
                  case '9':
                  case '10':
                    if (item.calculated_prices.fullday_price > 0) {
                      let room_price_vat =
                        parseFloat(item.calculated_prices.fullday_price) /
                        mt_length /
                        100
                      item.chosen_price = 'fullday'
                      item.what = room_price_vat
                      return room_price_vat
                    } else {
                      item.chosen_price = 'none'
                      return (
                        parseFloat(item.calculated_prices.price_vat) || Infinity
                      )
                    }
                    break
                  default:
                    item.chosen_price = 'none'
                    return (
                      parseFloat(item.calculated_prices.price_vat) || Infinity
                    ) // Infinity to put the rooms without prices to bottom.
                }
              }
            }
          ],
          ['desc', 'desc', 'desc', 'asc']
        )
      }

      // After get the final room list, mutate some states.
      commit('setRoomInfo', newlist)
      commit('setSelectedRoom', newlist[0].id)
      if (!state.isBE) {
        commit('setLayoutsInRoom', newlist[0].id)
      }
      commit('changeSelectedPrice', newlist[0].id)
    },
    sortRoomListinPackage({ commit, state }, rooms) {
      let mt_length = state.meeting_length
      let delegates = state.delegates

      // Get min delegates from room list in certain package.
      let roomMinArr = []
      rooms.forEach(el => {
        if (parseInt(el.available) == 1) {
          roomMinArr.push(el.min)
        }
      })

      let minNum = _.min(roomMinArr)
      commit('setMinRoomNumberinPackage', minNum)
      let roomList = []
      if (state.isBE) {
        roomList = _.orderBy(
          rooms,
          [
            function(item) {
              // Sort by availablity first. Available rooms will be first then to non-available rooms.
              return item.available
            },
            function(item) {
              // Sort by delegates
              let temp = ''
              if (
                parseInt(item.min) <= parseInt(delegates) &&
                parseInt(item.max) >= parseInt(delegates)
              ) {
                item.exceed = 'no'
                temp = 1
              } else {
                item.exceed = 'yes'
                temp = 0
              }
              return temp
            },
            function(item) {
              // Invalid Layout.
              let selectedLayout = state.selectedLayoutinPackage
              let layout_object = item.room_layout
              let layout_code = hf.getLayoutCode(selectedLayout)
              item.valid_layout = false
              let temp = 0
              for (let layout in layout_object) {
                if (
                  (layout == layout_code &&
                    parseInt(layout_object[layout]) >= state.delegates) ||
                  layout_code == '_none'
                ) {
                  item.valid_layout = true
                  temp = 1
                }
              }
              return temp
            },
            function(item) {
              // Sort smallest -- biggest room based on room max.
              return parseInt(item.max)
            }
          ],
          ['desc', 'desc', 'desc', 'asc']
        )
      } else {
        roomList = _.orderBy(
          rooms,
          [
            function(item) {
              // Sort by availablity first. Available rooms will be first then to non-available rooms.
              return item.available
            },
            function(item) {
              // Sort by delegates
              let temp = ''
              if (
                parseInt(item.min) <= parseInt(delegates) &&
                parseInt(item.max) >= parseInt(delegates)
              ) {
                item.exceed = 'no'
                temp = 1
              } else {
                item.exceed = 'yes'
                temp = 0
              }
              return temp
            },
            function(item) {
              // Sort smallest -- biggest room based on room max.
              return parseInt(item.max)
            }
          ],
          ['desc', 'desc', 'asc']
        )
      }

      // After get the final room list, mutate some states.
      commit('setRoomsInPackage', roomList)
      commit('setSelectedRoominPackage', roomList[0].id)
      if (!state.isBE) {
        commit('setLayoutsInRoom', roomList[0].id)
      }
      //commit('changeSelectedPrice', newlist[0].id);
    },
    filterAddons({commit, state}, data){
      return state.venueAddons.filter( addon  => {
          return addon.rooms && addon.rooms.includes(data.room_id.toString());
      });
    },
    sortPackageList({ dispatch, commit, state }, data) {
      state.packageInfo.forEach(element => {
        let count = 0
        let nonAvailCount = 0
        element.rooms.forEach(el => {
          if (el.available == 0) {
            nonAvailCount++
          }
          count++
        })
        if (count == nonAvailCount) {
          element.available = 0
        } else {
          element.available = 1
        }
      })

      let packagesList = _.orderBy(
        state.packageInfo,
        [
          function(item) {
            // Sort by room type first.
            let temp = ''
            switch (item.package_length) {
              case '4':
                temp = 0
                break
              case '8':
                temp = 1
                break
              case '24':
                temp = 2
                break
              case '36':
                temp = 3
                break
                return temp
            }
            return temp
          },
          function(item) {
            // Sort by delegates
            let temp = ''
            if (parseInt(item.package_max) >= parseInt(state.delegates)) {
              // need to check room here.
              let count = 0
              let roomExceedCount = 0
              let unavailableRoomCount = 0
              item.rooms.forEach(el => {
                if (
                  parseInt(el.max) < parseInt(state.delegates) ||
                  el.available == 0
                ) {
                  unavailableRoomCount++
                }
                count++
              })
              if (count == unavailableRoomCount) {
                item.allRoomUnavailable = 'yes'
                item.exceed = 'no'
                temp = 0
              } else {
                item.allRoomUnavailable = 'no'
                item.exceed = 'no'
                temp = 1
              }
            } else {
              item.allRoomUnavailable = 'yes'
              item.exceed = 'yes'
              temp = 0
            }
            return temp
          },
          function(item) {
            // Sort by price.
            var correctDelegates =
              parseInt(item.package_min) > parseInt(state.delegates)
                ? parseInt(item.package_min)
                : parseInt(state.delegates)
            return (
              parseInt(item.calculated_prices.price_vat) * correctDelegates ||
              Infinity
            )
          }
        ],
        ['asc', 'desc', 'asc']
      )
      // End sort.

      commit('setPackageInfo', packagesList)
      let pLength = ''
      switch (state.meeting_length.toString()) {
        case '2':
        case '3':
        case '4':
        case '5':
          pLength = 4
          break
        case '6':
        case '7':
        case '8':
        case '9':
        case '10':
          pLength = 8
          break
        case 'overnight':
          pLength = 24
          break
        case 'twodays':
          pLength = 36
          break
      }

      let selectedPackage = ''
      for (let element of packagesList) {
        if (parseInt(element.package_length) == pLength || element.is_new) {
          selectedPackage = element.id
          commit('setSelectedPackage', element.id)
          dispatch('sortRoomListinPackage', element.rooms)
          break
        }
      }

      let price = ''
      let selectedPrice = ''
      let selectedPrice_decimal = ''

      packagesList.forEach(element => {
        if (element.id == selectedPackage) {
          price = element.calculated_prices.price_vat / 100
          price = parseFloat(price).toFixed(2)
          selectedPrice = price.toString().split('.')[0]
          selectedPrice_decimal =
            typeof price.toString().split('.')[1] == 'undefined'
              ? '00'
              : price.toString().split('.')[1]

          commit('setSelectedPrice', {
            price,
            selectedPrice,
            selectedPrice_decimal
          })
        }
      })
    },
    checkAvailability({ dispatch, commit, state }, data) {
      let payload = {
        //'checkAvail' : 'yes'
      }

      dispatch('fetchMPRooms', payload).then(response => {
        let room_result = response.room_result.body
        let mergedList = _.map(state.roomInfo, function(item) {
          return _.extend(item, _.find(room_result, { id: item.id }))
        })

        dispatch('sortRoomList', {
          mergedList
        })
      })
    },
    checkAvailabilityandPrices({ dispatch, commit, state }, data) {
      let payload = {
        //'checkAvailandPrices' : 'yes'
      }
      if (data.fromDiscountCode) {
        commit('setDiscountCodeLoading', true)
      }
      dispatch('fetchMPRooms', payload).then(response => {
        let room_result = response.room_result.body
        let mergedList = _.map(state.roomInfo, function(item) {
          return _.extend(item, _.find(room_result, { id: item.id }))
        })
        if (data.fromDiscountCode) {
          commit('setDiscountCodeLoading', false)
        }
        dispatch('sortRoomList', {
          mergedList
        })
      })
    },
    checkAvailabilityfromPackage({ dispatch, commit, state }, data) {
      let payload = {
        checkAvail: 'yes'
      }
      dispatch('fetchMPRooms', payload).then(response => {
        let room_result = response.room_result.body
        let tempPackageList = state.packageInfo
        tempPackageList.forEach(element => {
          let newRoomList = _.map(element.rooms, function(item){
            return _.extend(item, _.find(room_result, { id: item.id }));
          });
          element.rooms = newRoomList;
        });
        dispatch('sortPackageList');
      });
    },
    applyDiscountCodeCheckout({dispatch,commit, state}, discountCode){
      commit('setDiscountCode', discountCode);
      commit('setDiscountCodeLoading', true);

      let payload = [];
      let type = '';
      state.checkOutItems.events.forEach( (event) => {
          type = event.type;
          payload.push(
            {
              "date": event.start, 
              "id": event.id, 
              "duration": event.duration, 
              "discount_code": discountCode,
            });
      });
      let events = state.checkOutItems.events;
      if(type == 'room'){
        dispatch('fetchMultipleRoomPrices', payload).then( (response) => {
            let discountedAmount = 0;
            let discountCodeFound = false
            let originalTotal = 0;
            events.forEach( (event, i) => {
                let foundPrice = response.body.find(obj => {
                    return parseInt(obj.id) == parseInt(event.id)
                 })
                if(foundPrice && foundPrice.type == "disc_price"){
                  discountCodeFound = true;
                  discountedAmount = discountedAmount + ( (foundPrice.base_price - foundPrice.price) / 100);
                  state.checkOutItems.events[i].discount_amount = (foundPrice.base_price - foundPrice.price) / 100;
                }
                if(foundPrice && foundPrice.type == "seasonal_price"){
                  foundPrice.base_price = foundPrice.price;
                }

                state.checkOutItems.events[i].base_price = foundPrice.base_price / 100;
                state.checkOutItems.events[i].duration_type = foundPrice.duration_type;
                commit('setRoomPriceLabel', foundPrice.duration_type);
                switch (foundPrice.duration_type) {
                  case 'halfday':
                  case 'fullday':
                    originalTotal = foundPrice.base_price / 100;
                    break;
                  case 'hourly':
                    discountedAmount = discountedAmount * state.checkOutItems.events[i].duration;
                    originalTotal = foundPrice.base_price / 100 * state.checkOutItems.events[i].duration;
                    break;
                  default:
                    break;
                }
                commit('setOriginalUnitPrice', originalTotal);

            });
            let newTotal = originalTotal - discountedAmount;
            if(newTotal > 0){
              state.checkOutItems.total = newTotal;
            }
            if(discountCodeFound){
              commit('setDiscountCodeInfo', 'found');
              state.checkOutItems.discount_code = discountCode;
            }else{
              state.checkOutItems.discount_code = '';
              commit('setDiscountCodeInfo', 'none_found');
            }
            commit('setDiscountedAmount', discountedAmount);
            commit('setDiscountCodeLoading', false);
        });
      } else {
        dispatch('fetchMultiplePackagePrices', payload).then( (response) => {
          let discountedAmount = 0;
          let discountCodeFound = false
          let originalTotal = 0;
          events.forEach( (event, i) => {
            let foundPrice = response.body.find(obj => {
                return obj.id == event.id
             })
             let delegates = state.checkOutItems.events[i].delegates;
             let package_min = state.checkOutItems.events[i].package_min;

             let finalDelegates = parseInt(delegates) > parseInt(package_min) ? parseInt(delegates) : parseInt(package_min);
             if(foundPrice && foundPrice.type == "disc_price"){
                discountCodeFound = true;
                discountedAmount = discountedAmount + ( (foundPrice.base_price - foundPrice.price_vat) / 100);
                discountedAmount = discountedAmount * finalDelegates;
                state.checkOutItems.events[i].discount_amount = (foundPrice.base_price - foundPrice.price_vat) / 100;
              }

              if(foundPrice && foundPrice.type == "seasonal_price"){
                foundPrice.base_price = foundPrice.price_vat;
              }

              state.checkOutItems.events[i].base_price = parseFloat(foundPrice.base_price) / 100;
              commit('setOriginalUnitPrice', parseFloat(foundPrice.base_price) / 100);
              originalTotal = finalDelegates * parseFloat(foundPrice.base_price) / 100;
          });
          let newTotal = originalTotal - discountedAmount;
          if(newTotal > 0){
            state.checkOutItems.total = newTotal;
          }
          if(discountCodeFound){
            commit('setDiscountCodeInfo', 'found');
            state.checkOutItems.discount_code = discountCode;
          }else{
            commit('setDiscountCodeInfo', 'none_found');
            state.checkOutItems.discount_code = '';
          }
          commit('setDiscountedAmount', discountedAmount);
          commit('setDiscountCodeLoading', false);
          commit('setCheckOutItems', state.checkOutItems);
        });
      }
    },
    checkAvailabilityandPricesfromPackage({dispatch,commit, state}, data) {
      if(data.fromDiscountCode){
        commit('setDiscountCodeLoading', true);
      }  
      dispatch('fetchMPPackages').then((response) => {
        let packages = response.package_result.body;
        // Sort packages.
        if (data.fromDiscountCode) {
          commit('setDiscountCodeLoading', false)
        }
        commit('setPackageInfo', packages)
        dispatch('sortPackageList')
      })
    },
    getVenueAddons({ dispatch, commit, state }, data) {
      let venueID = data.venue_id
      return new Promise((resolve, reject) => {
        Vue.http.get(state.baseUrl + '/' + 'apiv2/catalog/index/' + venueID).then(response => {
          if(data == "package_pms_not_mapped"){
            commit('pmsPackageError', true)
            resolve()
          }
          commit('setVenueAddons', response.body)
          if (data.room_id) {
            response = dispatch('filterAddons', { room_id: data.room_id })
          }
          return resolve(response.body)
        })
      })
    },
    createBooking({ dispatch, commit, state }, data) {
      return new Promise((resolve, reject) => {
        Vue.http.post(state.baseUrl + '/' + 'apiv2/book', data).then(response => {
          if (response.body.challenge && response.body.error) {
            commit('setChallengeError', response.body.error)
          }
          if (response.body.challenge) {
            commit('setChallengeRequired', true)
            reject('challenge')
          }
          return resolve(response.body)
        })
      })
    },
    validateUser({dispatch, commit, state}, data){
      return new Promise((resolve,reject) => {
        Vue.http.post(state.baseUrl + '/' + 'apiv2/validate_email', data).then(response => {
          if(response.body.challenge && response.body.error){
            commit('setChallengeError', response.body.error);
          }
          if(response.body.challenge){
            commit('setChallengeRequired', true);
            reject("challenge");
          }
          return resolve(response.body);
        });
      });
    },
    gTranslate({dispatch, commit, state}, data) {
      return new Promise((resolve, reject) => {
        let translateText = {
          q: data.text,
          format: 'html',
          target: data.lang
        }

        Vue.http.interceptors.push((request, next) => {
          commit('isTranslating', true)
          next(response => {
            commit('isTranslating', false)
          })
        })

        /*
        Vue.http.post('https://translation.googleapis.com/language/translate/v2?key=123', translateText).then(response => {
          commit('translatedLanguage', response.body.data.translations['0'].translatedText);
        }, response => {
        });
        */
        commit('translatedLanguage', data.lang)
      })
    },
    gTranslateRoom({ dispatch, commit, state }, data) {
      return new Promise((resolve, reject) => {
        let translateText = {
          q: data.text,
          format: 'html',
          target: data.lang
        }

        Vue.http.interceptors.push((request, next) => {
          commit('isTranslating', true)
          next(response => {
            commit('isTranslating', false)
          })
        })

        resolve(data.text)

        /*Vue.http.post('https://translation.googleapis.com/language/translate/v2?key=123', translateText).then(response => {
           resolve(response.body.data.translations['0'].translatedText);
        }, response => {
        });*/
      })
    },
    gTranslateDetect({ commit, state }, data) {
      return new Promise((resolve, reject) => {
        let detectText = {
          q: data
        }

        Vue.http.interceptors.push((request, next) => {
          commit('setLoading', true)
          next(response => {
            commit('setLoading', false)
          })
        })

        let siteUrl = window.location.hostname
        if (
          siteUrl != 'dev.meetingpackage.com' &&
          siteUrl != 'stage.meetingpackage.com' &&
          siteUrl != 'mpfeature.meetingpackage.com'
        ) {
          commit('detectedLanguage', state.selectedLang)
          /*
          Vue.http.post('https://translation.googleapis.com/language/translate/v2/detect?key=123', detectText).then(response => {
            commit('detectedLanguage', response.body.data.detections['0']['0'].language);
          }, response => {
          });
          */
        }
      })
    }
  }
})
